import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAutomaticRefinement = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M53.03 14.21L50.75 13.08L52.44 12.47L54.72 13.61L53.03 14.21Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.67 27.73L45.38 26.6L44.9 24.85L47.18 25.98L47.67 27.73Z",
			fill: "#203E76"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.12 17.01C51.24 19.07 49.95 21.66 48.23 22.79C47.38 23.35 46.58 23.45 45.97 23.15L43.69 22.02C44.29 22.32 45.09 22.22 45.95 21.66C47.67 20.53 48.96 17.94 48.84 15.88C48.78 14.84 48.37 14.13 47.76 13.83L50.04 14.96C50.65 15.26 51.06 15.97 51.12 17.01Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.43 11.86L48.14 10.73L49.54 8.7L51.82 9.84L50.43 11.86Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.93 27.63L40.65 26.5L41.46 24.18L43.74 25.31L42.93 27.63Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.7 11.9C49.41 11.94 49.12 12.02 48.83 12.13L46.55 11C46.85 10.89 47.14 10.81 47.42 10.77C47.68 10.73 47.94 10.72 48.15 10.73L50.43 11.86C50.22 11.86 49.97 11.86 49.7 11.9Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.31 24.69C43.44 24.92 43.58 25.13 43.74 25.32L41.46 24.19C41.3 24.01 41.15 23.8 41.03 23.56C40.89 23.3 40.78 23.02 40.69 22.77L42.97 23.9C43.06 24.16 43.17 24.44 43.31 24.69Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.61 14.59C45.36 14.89 45.13 15.2 44.91 15.53L42.63 14.4C42.85 14.07 43.09 13.76 43.33 13.46C43.6 13.14 43.88 12.84 44.12 12.59L46.4 13.72C46.15 13.97 45.87 14.26 45.61 14.59Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.02 19.78C42.92 20.19 42.85 20.59 42.8 20.99L40.52 19.86C40.57 19.47 40.64 19.06 40.74 18.65C40.83 18.27 40.94 17.9 41.04 17.58L43.32 18.71C43.22 19.03 43.11 19.41 43.02 19.78Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.68 11.46L44.4 10.33L46.06 9.23999L48.34 10.37L46.68 11.46Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.4 13.72L44.12 12.59L44.4 10.33L46.68 11.46L46.4 13.72Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.17 22.51L38.88 21.38L40.52 19.85L42.8 20.98L41.17 22.51Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.29 24.5L39 23.37L38.88 21.38L41.17 22.51L41.29 24.5Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.41 15.36L41.13 14.23L42.62 14.39L44.9 15.52L43.41 15.36Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.32 18.7L41.03 17.57L40.04 16.41L42.32 17.54L43.32 18.7Z",
			fill: "#203E76"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.83 12.13L48.35 10.38L46.69 11.47L46.41 13.73C46.16 13.98 45.88 14.27 45.62 14.6C45.37 14.9 45.14 15.21 44.92 15.54L43.42 15.38L42.33 17.56L43.33 18.73C43.23 19.05 43.12 19.43 43.03 19.8C42.93 20.21 42.86 20.61 42.81 21.01L41.18 22.54L41.3 24.53L42.99 23.92C43.08 24.18 43.19 24.46 43.33 24.71C43.46 24.94 43.6 25.15 43.76 25.34L42.95 27.66L44.21 28.3L45.6 26.27C45.81 26.27 46.07 26.27 46.33 26.23C46.62 26.19 46.91 26.11 47.2 26L47.68 27.75L49.34 26.66L49.62 24.4C49.87 24.15 50.15 23.86 50.41 23.53C50.66 23.23 50.89 22.92 51.11 22.6L52.61 22.76L53.7 20.58L52.7 19.41C52.8 19.09 52.91 18.71 53 18.34C53.1 17.93 53.17 17.53 53.22 17.13L54.85 15.6L54.73 13.61L53.04 14.22C52.95 13.96 52.84 13.68 52.7 13.43C52.57 13.2 52.43 12.99 52.27 12.8L53.08 10.48L51.82 9.84L50.43 11.86C50.22 11.86 49.97 11.86 49.7 11.9C49.41 11.94 49.12 12.02 48.83 12.13ZM51.12 17.01C51.24 19.07 49.95 21.66 48.23 22.79C46.51 23.92 45.02 23.16 44.89 21.1C44.77 19.04 46.06 16.45 47.78 15.32C49.5 14.19 50.99 14.95 51.12 17.01Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.32 17.54L40.04 16.41L41.13 14.23L43.41 15.36L42.32 17.54Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.94 10.3L52.63 10.65L51.92 12.67C51.88 12.79 51.9 12.93 51.99 13.03C52.13 13.19 52.26 13.38 52.38 13.59C52.49 13.8 52.6 14.06 52.69 14.33C52.72 14.42 52.79 14.5 52.88 14.54C52.93 14.56 52.98 14.58 53.04 14.58C53.08 14.58 53.12 14.58 53.16 14.56L54.39 14.12L54.47 15.46L52.96 16.87C52.9 16.93 52.86 17.01 52.85 17.09C52.8 17.47 52.73 17.86 52.64 18.25C52.56 18.57 52.47 18.92 52.35 19.3C52.31 19.42 52.34 19.55 52.42 19.64L53.26 20.62L52.39 22.36L51.15 22.22C51.15 22.22 51.12 22.22 51.11 22.22C50.99 22.22 50.88 22.28 50.81 22.38C50.59 22.7 50.36 23 50.13 23.29C49.9 23.57 49.63 23.86 49.36 24.13C49.3 24.19 49.27 24.26 49.26 24.34L49 26.43L47.9 27.15L47.55 25.88C47.52 25.78 47.46 25.7 47.37 25.65C47.32 25.62 47.26 25.61 47.2 25.61C47.16 25.61 47.11 25.61 47.07 25.63C46.8 25.73 46.53 25.8 46.27 25.84C46.09 25.87 45.91 25.88 45.71 25.88H45.6C45.48 25.88 45.37 25.94 45.3 26.04L44.09 27.8L43.4 27.45L44.11 25.43C44.15 25.31 44.13 25.17 44.04 25.07C43.9 24.91 43.77 24.72 43.65 24.51C43.54 24.3 43.43 24.04 43.34 23.77C43.31 23.68 43.24 23.6 43.15 23.56C43.1 23.54 43.05 23.52 42.99 23.52C42.95 23.52 42.91 23.52 42.87 23.54L41.64 23.98L41.56 22.64L43.07 21.23C43.13 21.17 43.17 21.09 43.18 21.01C43.23 20.63 43.3 20.24 43.39 19.85C43.47 19.53 43.56 19.18 43.68 18.8C43.72 18.68 43.69 18.55 43.61 18.46L42.77 17.48L43.64 15.74L44.88 15.88C44.88 15.88 44.91 15.88 44.92 15.88C45.04 15.88 45.15 15.82 45.22 15.72C45.44 15.4 45.67 15.1 45.9 14.81C46.13 14.53 46.4 14.24 46.67 13.97C46.73 13.91 46.76 13.84 46.77 13.76L47.03 11.67L48.13 10.95L48.48 12.22C48.51 12.32 48.57 12.4 48.66 12.45C48.71 12.48 48.77 12.49 48.83 12.49C48.87 12.49 48.92 12.49 48.96 12.47C49.23 12.37 49.5 12.3 49.76 12.26C49.93 12.23 50.12 12.22 50.32 12.22H50.43C50.55 12.22 50.66 12.16 50.73 12.06L51.94 10.3ZM46.71 23.67C47.25 23.67 47.85 23.47 48.43 23.09C50.24 21.9 51.61 19.16 51.48 16.99C51.39 15.44 50.53 14.43 49.3 14.43C48.76 14.43 48.16 14.63 47.58 15.01C45.77 16.2 44.4 18.94 44.53 21.11C44.62 22.66 45.48 23.67 46.71 23.67ZM51.82 9.84L50.43 11.87C50.43 11.87 50.35 11.87 50.31 11.87C50.13 11.87 49.92 11.88 49.7 11.91C49.41 11.95 49.12 12.03 48.83 12.14L48.35 10.39L46.69 11.48L46.41 13.74C46.16 13.99 45.88 14.28 45.62 14.61C45.37 14.91 45.14 15.22 44.92 15.55L43.42 15.39L42.33 17.57L43.33 18.74C43.23 19.06 43.12 19.44 43.03 19.81C42.93 20.22 42.86 20.62 42.81 21.02L41.18 22.55L41.3 24.54L42.99 23.93C43.08 24.19 43.19 24.47 43.33 24.72C43.46 24.95 43.6 25.16 43.76 25.35L42.95 27.67L44.21 28.31L45.6 26.28C45.6 26.28 45.68 26.28 45.72 26.28C45.9 26.28 46.11 26.27 46.33 26.24C46.62 26.2 46.91 26.12 47.2 26.01L47.68 27.76L49.34 26.67L49.62 24.41C49.87 24.16 50.15 23.87 50.41 23.54C50.66 23.24 50.89 22.93 51.11 22.61L52.61 22.77L53.7 20.59L52.7 19.42C52.8 19.1 52.91 18.72 53 18.35C53.1 17.94 53.17 17.54 53.22 17.14L54.85 15.61L54.73 13.62L53.04 14.23C52.95 13.97 52.84 13.69 52.7 13.44C52.57 13.21 52.43 13 52.27 12.81L53.08 10.49L51.82 9.85V9.84ZM46.71 23.31C45.71 23.31 44.98 22.51 44.89 21.1C44.77 19.04 46.06 16.45 47.78 15.32C48.32 14.97 48.84 14.8 49.3 14.8C50.3 14.8 51.03 15.6 51.12 17.01C51.24 19.07 49.95 21.66 48.23 22.79C47.69 23.15 47.17 23.31 46.71 23.31Z",
			fill: "url(#paint0_linear_4252_2707)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.42 8.97L24.31 7.43L26.61 6.61L29.71 8.15L27.42 8.97Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.12 27.36L17.01 25.82L16.35 23.43L19.46 24.97L20.12 27.36Z",
			fill: "#203E76"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.81 12.77C24.98 15.58 23.22 19.09 20.88 20.63C19.72 21.39 18.63 21.52 17.81 21.12L14.7 19.58C15.52 19.99 16.61 19.86 17.77 19.09C20.11 17.55 21.87 14.04 21.7 11.23C21.61 9.82 21.06 8.86 20.23 8.44L23.34 9.98C24.17 10.39 24.73 11.35 24.81 12.77Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.87 5.77L20.77 4.23L22.66 1.48L25.77 3.02L23.87 5.77Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.68 27.22L10.57 25.68L11.68 22.53L14.78 24.07L13.68 27.22Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.88 5.83C22.49 5.89 22.09 5.99 21.69 6.14L18.58 4.6C18.98 4.45 19.38 4.35 19.77 4.29C20.13 4.24 20.47 4.23 20.76 4.23L23.87 5.77C23.58 5.77 23.24 5.77 22.88 5.83Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2 23.22C14.37 23.54 14.57 23.82 14.79 24.07L11.68 22.53C11.46 22.28 11.26 22 11.09 21.68C10.9 21.33 10.75 20.95 10.63 20.6L13.74 22.14C13.86 22.49 14.01 22.87 14.2 23.22Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.32 9.47999C16.98 9.87999 16.67 10.31 16.36 10.75L13.25 9.20999C13.55 8.76999 13.87 8.33999 14.21 7.93999C14.58 7.49999 14.95 7.09999 15.29 6.75999L18.4 8.29999C18.06 8.63999 17.69 9.03999 17.32 9.47999Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.79 16.54C13.66 17.1 13.56 17.65 13.5 18.18L10.39 16.64C10.45 16.11 10.55 15.56 10.68 15C10.8 14.49 10.95 13.98 11.09 13.54L14.2 15.08C14.06 15.52 13.91 16.03 13.79 16.54Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.78 5.22999L15.68 3.68999L17.93 2.20999L21.04 3.74999L18.78 5.22999Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4 8.3L15.29 6.76L15.68 3.69L18.78 5.23L18.4 8.3Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.28 20.25L8.17 18.71L10.39 16.64L13.5 18.18L11.28 20.25Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.44 22.96L8.34 21.42L8.17 18.71L11.28 20.25L11.44 22.96Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.33 10.53L11.22 8.98999L13.26 9.20999L16.36 10.75L14.33 10.53Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2 15.08L11.1 13.54L9.74 11.95L12.85 13.49L14.2 15.08Z",
			fill: "#203E76"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.7 6.13999L21.04 3.74999L18.78 5.22999L18.4 8.29999C18.06 8.63999 17.69 9.03999 17.32 9.47999C16.98 9.87999 16.67 10.31 16.36 10.75L14.33 10.53L12.85 13.49L14.2 15.07C14.06 15.51 13.91 16.02 13.79 16.53C13.66 17.09 13.56 17.64 13.5 18.17L11.28 20.24L11.44 22.95L13.74 22.12C13.86 22.47 14.01 22.85 14.2 23.2C14.37 23.52 14.57 23.8 14.79 24.05L13.68 27.2L15.39 28.07L17.28 25.32C17.57 25.32 17.91 25.32 18.27 25.26C18.66 25.2 19.06 25.1 19.46 24.95L20.12 27.33L22.38 25.85L22.76 22.78C23.1 22.44 23.47 22.04 23.84 21.6C24.18 21.2 24.49 20.77 24.8 20.33L26.83 20.55L28.31 17.59L26.96 16.01C27.1 15.57 27.25 15.06 27.37 14.55C27.5 13.99 27.6 13.44 27.66 12.91L29.88 10.84L29.72 8.12999L27.42 8.95999C27.3 8.60999 27.15 8.22999 26.96 7.87999C26.79 7.55999 26.59 7.27999 26.37 7.02999L27.48 3.87999L25.77 3.00999L23.87 5.75999C23.58 5.75999 23.24 5.75999 22.88 5.81999C22.49 5.87999 22.09 5.97999 21.69 6.12999L21.7 6.13999ZM24.81 12.77C24.98 15.58 23.22 19.09 20.88 20.63C18.54 22.17 16.51 21.14 16.34 18.33C16.17 15.52 17.93 12.01 20.27 10.47C22.61 8.92999 24.64 9.95999 24.81 12.77Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.85 13.49L9.74 11.95L11.22 8.98999L14.33 10.53L12.85 13.49Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.93 3.65999L26.86 4.12999L25.9 6.86999C25.84 7.03999 25.88 7.22999 26 7.36999C26.2 7.58999 26.37 7.84999 26.52 8.12999C26.67 8.41999 26.82 8.75999 26.94 9.12999C26.98 9.25999 27.07 9.35999 27.2 9.41999C27.27 9.44999 27.34 9.46999 27.42 9.46999C27.48 9.46999 27.53 9.46999 27.59 9.43999L29.26 8.83999L29.37 10.65L27.32 12.56C27.23 12.64 27.18 12.75 27.16 12.87C27.1 13.39 27 13.92 26.88 14.45C26.78 14.89 26.64 15.36 26.48 15.87C26.43 16.03 26.46 16.21 26.58 16.35L27.72 17.68L26.54 20.04L24.85 19.86C24.85 19.86 24.81 19.86 24.8 19.86C24.64 19.86 24.48 19.94 24.39 20.08C24.1 20.51 23.78 20.93 23.46 21.31C23.14 21.69 22.78 22.09 22.41 22.46C22.33 22.54 22.28 22.64 22.27 22.75L21.92 25.59L20.43 26.57L19.96 24.85C19.92 24.71 19.83 24.6 19.71 24.54C19.64 24.5 19.56 24.48 19.48 24.48C19.42 24.48 19.36 24.49 19.31 24.51C18.94 24.65 18.58 24.74 18.22 24.79C17.98 24.82 17.73 24.84 17.46 24.84H17.31C17.31 24.84 17.31 24.84 17.3 24.84C17.14 24.84 16.98 24.92 16.89 25.06L15.24 27.45L14.31 26.98L15.27 24.24C15.33 24.07 15.29 23.88 15.17 23.74C14.97 23.52 14.8 23.26 14.65 22.98C14.5 22.69 14.35 22.34 14.23 21.98C14.19 21.85 14.1 21.75 13.97 21.69C13.9 21.66 13.83 21.64 13.75 21.64C13.69 21.64 13.64 21.64 13.58 21.67L11.91 22.27L11.8 20.46L13.85 18.55C13.94 18.47 13.99 18.36 14.01 18.24C14.07 17.72 14.17 17.19 14.29 16.66C14.39 16.22 14.53 15.75 14.69 15.24C14.74 15.08 14.71 14.9 14.59 14.76L13.45 13.43L14.63 11.07L16.32 11.25C16.32 11.25 16.36 11.25 16.37 11.25C16.53 11.25 16.69 11.17 16.78 11.03C17.07 10.6 17.39 10.18 17.71 9.79999C18.03 9.41999 18.39 9.01999 18.76 8.64999C18.84 8.56999 18.89 8.46999 18.9 8.35999L19.25 5.51999L20.74 4.53999L21.21 6.25999C21.25 6.39999 21.34 6.50999 21.46 6.56999C21.53 6.60999 21.61 6.61999 21.69 6.61999C21.75 6.61999 21.81 6.60999 21.86 6.58999C22.23 6.44999 22.59 6.35999 22.95 6.30999C23.19 6.27999 23.44 6.25999 23.7 6.25999H23.85C23.85 6.25999 23.85 6.25999 23.86 6.25999C24.02 6.25999 24.18 6.17999 24.27 6.03999L25.92 3.64999M18.82 21.85C19.56 21.85 20.37 21.58 21.16 21.06C23.63 19.44 25.49 15.71 25.31 12.75C25.18 10.63 24.02 9.26999 22.34 9.26999C21.6 9.26999 20.79 9.53999 20 10.06C17.53 11.68 15.67 15.41 15.85 18.37C15.98 20.49 17.14 21.85 18.82 21.85ZM25.77 3.01999L23.87 5.76999C23.82 5.76999 23.76 5.76999 23.71 5.76999C23.46 5.76999 23.18 5.77999 22.88 5.82999C22.49 5.88999 22.09 5.98999 21.69 6.13999L21.03 3.74999L18.77 5.22999L18.39 8.29999C18.05 8.63999 17.68 9.03999 17.31 9.47999C16.97 9.87999 16.66 10.31 16.35 10.75L14.32 10.53L12.84 13.49L14.19 15.07C14.05 15.51 13.9 16.02 13.78 16.53C13.65 17.09 13.55 17.64 13.49 18.17L11.27 20.24L11.43 22.95L13.73 22.12C13.85 22.47 14 22.85 14.19 23.2C14.36 23.52 14.56 23.8 14.78 24.05L13.67 27.2L15.38 28.07L17.27 25.32C17.32 25.32 17.38 25.32 17.43 25.32C17.68 25.32 17.97 25.31 18.26 25.26C18.65 25.2 19.05 25.1 19.45 24.95L20.11 27.33L22.37 25.85L22.75 22.78C23.09 22.44 23.46 22.04 23.83 21.6C24.17 21.2 24.48 20.77 24.79 20.33L26.82 20.55L28.3 17.59L26.95 16.01C27.09 15.57 27.24 15.06 27.36 14.55C27.49 13.99 27.59 13.44 27.65 12.91L29.87 10.84L29.71 8.12999L27.41 8.95999C27.29 8.60999 27.14 8.22999 26.95 7.87999C26.78 7.55999 26.58 7.27999 26.36 7.02999L27.47 3.87999L25.76 3.00999L25.77 3.01999ZM18.82 21.35C17.45 21.35 16.46 20.26 16.35 18.34C16.18 15.53 17.94 12.02 20.28 10.48C21.02 9.99999 21.72 9.76999 22.35 9.76999C23.72 9.76999 24.71 10.86 24.82 12.78C24.99 15.59 23.23 19.1 20.89 20.64C20.15 21.12 19.45 21.35 18.82 21.35Z",
			fill: "url(#paint1_linear_4252_2707)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.56 25.74L37.47 23.22L41.23 21.86L46.33 24.39L42.56 25.74Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.59 55.89L25.49 53.37L24.42 49.45L29.51 51.98L30.59 55.89Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.29 31.98C38.57 36.58 35.68 42.35 31.85 44.87C29.95 46.12 28.16 46.33 26.82 45.67L21.73 43.14C23.07 43.81 24.86 43.59 26.76 42.34C30.59 39.82 33.48 34.05 33.2 29.45C33.06 27.13 32.15 25.56 30.79 24.88L35.88 27.41C37.24 28.09 38.16 29.66 38.29 31.98Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.75 20.49L31.65 17.97L34.76 13.45L39.86 15.98L36.75 20.49Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.03 55.67L14.93 53.14L16.75 47.97L21.84 50.5L20.03 55.67Z",
			fill: "#DE8704"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.12 20.58C34.48 20.67 33.83 20.84 33.17 21.09L28.08 18.56C28.74 18.32 29.39 18.15 30.03 18.05C30.62 17.96 31.18 17.95 31.65 17.96L36.74 20.49C36.27 20.48 35.7 20.49 35.12 20.58Z",
			fill: "#DE8704"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.88 49.1C21.16 49.62 21.48 50.09 21.84 50.5L16.75 47.97C16.39 47.56 16.07 47.09 15.79 46.57C15.48 46 15.23 45.37 15.04 44.8L20.13 47.33C20.32 47.9 20.57 48.53 20.88 49.1Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 26.58C25.45 27.24 24.93 27.94 24.43 28.67L19.34 26.14C19.83 25.41 20.36 24.72 20.91 24.05C21.51 23.33 22.13 22.66 22.68 22.11L27.77 24.64C27.22 25.19 26.6 25.85 26 26.58Z",
			fill: "#FFCB47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.22 38.15C20 39.06 19.84 39.96 19.74 40.84L14.65 38.31C14.75 37.43 14.91 36.54 15.13 35.62C15.33 34.78 15.57 33.94 15.8 33.23L20.89 35.76C20.66 36.47 20.42 37.31 20.22 38.15Z",
			fill: "#FFBB0E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.4 19.61L23.3 17.08L27.01 14.65L32.1 17.18L28.4 19.61Z",
			fill: "#FFCB47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.77 24.64L22.68 22.12L23.3 17.08L28.4 19.61L27.77 24.64Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.09 44.24L11 41.71L14.64 38.31L19.74 40.84L16.09 44.24Z",
			fill: "#DE8704"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.36 48.68L11.27 46.16L11 41.71L16.09 44.24L16.36 48.68Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.09 28.3L16 25.77L19.34 26.14L24.43 28.66L21.09 28.3Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.89 35.76L15.79 33.23L13.57 30.63L18.67 33.16L20.89 35.76Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.18 21.09L32.1 17.18L28.4 19.61L27.77 24.64C27.22 25.19 26.6 25.85 26 26.58C25.45 27.24 24.93 27.94 24.43 28.67L21.09 28.3L18.66 33.16L20.88 35.76C20.65 36.47 20.41 37.31 20.21 38.15C19.99 39.06 19.83 39.96 19.73 40.84L16.09 44.24L16.36 48.68L20.13 47.32C20.32 47.89 20.57 48.52 20.88 49.09C21.16 49.61 21.48 50.08 21.84 50.49L20.02 55.66L22.83 57.08L25.94 52.56C26.41 52.57 26.98 52.56 27.56 52.47C28.2 52.38 28.85 52.21 29.51 51.96L30.59 55.87L34.29 53.44L34.92 48.41C35.47 47.86 36.09 47.2 36.69 46.47C37.24 45.81 37.76 45.11 38.26 44.38L41.6 44.74L44.03 39.88L41.81 37.28C42.04 36.57 42.28 35.73 42.48 34.89C42.7 33.98 42.86 33.08 42.96 32.2L46.6 28.8L46.33 24.36L42.56 25.72C42.37 25.15 42.12 24.52 41.81 23.95C41.53 23.43 41.21 22.96 40.85 22.55L42.67 17.38L39.86 15.96L36.75 20.48C36.28 20.47 35.71 20.48 35.13 20.57C34.49 20.66 33.84 20.83 33.18 21.08V21.09ZM38.29 31.98C38.57 36.58 35.68 42.35 31.85 44.87C28.02 47.39 24.68 45.7 24.4 41.1C24.12 36.5 27.01 30.73 30.84 28.21C34.67 25.69 38.01 27.38 38.29 31.98Z",
			fill: "#FFE091"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.67 33.16L13.57 30.63L16 25.77L21.09 28.3L18.67 33.16Z",
			fill: "#FFCB47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.02 16.62L42.05 17.65L40.38 22.41L40.28 22.69L40.47 22.91C40.81 23.29 41.11 23.73 41.37 24.22C41.63 24.71 41.88 25.29 42.09 25.91L42.25 26.4L42.73 26.23L45.87 25.1L46.08 28.64L42.61 31.88L42.48 32L42.46 32.18C42.36 33.04 42.2 33.92 41.99 34.81C41.82 35.53 41.6 36.33 41.33 37.17L41.25 37.43L41.43 37.64L43.43 39.99L41.31 44.24L38.32 43.91L38.02 43.88L37.85 44.13C37.36 44.85 36.84 45.54 36.31 46.18C35.78 46.81 35.18 47.47 34.57 48.08L34.45 48.2L34.43 48.37L33.83 53.17L30.89 55.1L29.99 51.85L29.85 51.32L29.34 51.51C28.71 51.74 28.09 51.9 27.5 51.99C27.09 52.05 26.66 52.08 26.22 52.08C26.13 52.08 26.05 52.08 25.97 52.08H25.7L25.55 52.3L22.69 56.46L20.66 55.43L22.33 50.67L22.43 50.39L22.24 50.17C21.9 49.79 21.6 49.35 21.34 48.86C21.08 48.37 20.83 47.79 20.62 47.17L20.46 46.68L19.98 46.85L16.84 47.98L16.63 44.44L20.1 41.2L20.23 41.08L20.25 40.9C20.35 40.04 20.51 39.16 20.72 38.27C20.89 37.55 21.11 36.75 21.38 35.91L21.46 35.65L21.28 35.44L19.28 33.09L21.4 28.84L24.39 29.17L24.69 29.2L24.86 28.95C25.35 28.23 25.87 27.54 26.4 26.9C26.93 26.27 27.53 25.61 28.14 25L28.26 24.88L28.28 24.71L28.88 19.91L31.82 17.98L32.71 21.23L32.85 21.76L33.36 21.57C33.99 21.34 34.61 21.18 35.21 21.09C35.61 21.03 36.05 21 36.49 21C36.58 21 36.66 21 36.75 21H37.02L37.17 20.78L40.03 16.62M28.46 46.53C29.61 46.53 30.88 46.1 32.12 45.28C36.08 42.68 39.07 36.7 38.78 31.94C38.58 28.6 36.83 26.53 34.22 26.53C33.07 26.53 31.8 26.96 30.56 27.78C26.6 30.38 23.61 36.36 23.9 41.12C24.1 44.46 25.85 46.53 28.46 46.53ZM39.86 15.98L36.75 20.5C36.66 20.5 36.57 20.5 36.48 20.5C36.07 20.5 35.6 20.52 35.13 20.59C34.49 20.68 33.84 20.85 33.18 21.1L32.1 17.19L28.4 19.62L27.77 24.65C27.22 25.2 26.6 25.86 26 26.59C25.45 27.25 24.93 27.95 24.43 28.68L21.09 28.32L18.66 33.18L20.88 35.78C20.65 36.49 20.41 37.33 20.21 38.17C19.99 39.08 19.83 39.98 19.73 40.86L16.09 44.26L16.36 48.7L20.13 47.34C20.32 47.91 20.57 48.54 20.88 49.11C21.16 49.63 21.48 50.1 21.84 50.51L20.02 55.68L22.83 57.1L25.94 52.58C26.03 52.58 26.11 52.58 26.21 52.58C26.62 52.58 27.09 52.56 27.57 52.49C28.21 52.4 28.86 52.23 29.52 51.98L30.6 55.89L34.3 53.46L34.93 48.43C35.48 47.88 36.1 47.22 36.7 46.49C37.25 45.83 37.77 45.13 38.27 44.4L41.61 44.76L44.04 39.9L41.82 37.3C42.05 36.59 42.29 35.75 42.49 34.91C42.71 34 42.87 33.1 42.97 32.22L46.61 28.82L46.34 24.38L42.57 25.74C42.38 25.17 42.13 24.54 41.82 23.97C41.54 23.45 41.22 22.98 40.86 22.57L42.68 17.4L39.87 15.98H39.86ZM28.46 46.03C26.22 46.03 24.59 44.24 24.4 41.09C24.12 36.49 27.01 30.72 30.84 28.2C32.05 27.41 33.2 27.03 34.23 27.03C36.47 27.03 38.1 28.82 38.29 31.97C38.57 36.57 35.68 42.34 31.85 44.86C30.64 45.65 29.49 46.03 28.46 46.03Z",
			fill: "#FFE091"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.99 24.01C60 23.08 59.37 21.95 58.58 21.47C58.18 21.23 57.82 21.2 57.55 21.35L47.22 27.57C47.19 27.58 47.16 27.6 47.13 27.62C46.95 27.75 46.84 27.99 46.83 28.32C46.82 29.05 47.32 29.94 47.94 30.32C48.28 30.53 48.59 30.53 48.81 30.37L59.48 24.97C59.78 24.83 59.98 24.5 59.98 24L59.99 24.01Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.49 29.71C48.49 29.15 48.1 28.47 47.61 28.19C47.34 28.04 47.1 28.04 46.94 28.16L44.46 29.65L45.74 31.78L48.2 30.3C48.2 30.3 48.25 30.28 48.27 30.26C48.41 30.16 48.49 29.97 48.49 29.72V29.71Z",
			fill: "#FFCB47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.52 31.49C41.55 32.16 41.52 32.86 41.45 33.56C41.26 35.28 40.77 37.07 40.04 38.78C39.38 40.33 38.53 41.83 37.54 43.17C36.32 44.82 34.89 46.23 33.34 47.22C31.75 48.23 30.24 48.67 28.93 48.6C30.56 50.68 33.43 50.95 36.61 48.92C38.16 47.93 39.59 46.52 40.81 44.87C41.8 43.53 42.65 42.04 43.31 40.48C44.04 38.76 44.53 36.98 44.72 35.26C44.8 34.56 44.82 33.86 44.8 33.19C44.63 29.42 42.77 27.23 40.13 27.08C40.94 28.12 41.45 29.61 41.53 31.49H41.52Z",
			fill: "#DE8704"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.5 26.97L42.45 27.89C43.81 28.86 44.68 30.68 44.79 33.2C45.04 38.85 41.37 45.89 36.61 48.93C34.78 50.09 33.06 50.5 31.61 50.24L31.28 51.61C33.07 52.03 35.06 51.64 37.35 50.13C39.82 48.49 42.13 45.85 43.79 42.67C45.44 39.49 46.28 36.11 46.15 33.14C46.03 30.4 45.1 28.25 43.5 26.97Z",
			fill: "#FFF3D5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8 27.06L59.01 49.85V38.57L38.4 26.68L37.8 27.06Z",
			fill: "#BABABA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.4 37.96L59.01 49.85L45.16 57.8L24.55 45.9L38.4 37.96Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.8 38.34L58.41 50.24V38.96L37.8 27.06V38.34Z",
			fill: "#929292"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M44.06 29.94L43.37 30.33L43.62 38.65L38.15 35.44L37.73 26.33L44.06 29.94Z",
				fill: "#F8F8F8"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.08 30.9L34.38 30.09C34.42 29.97 34.51 29.86 34.6 29.81L39.99 26.64C40.05 26.6 40.11 26.6 40.15 26.62C40.17 26.62 40.48 26.77 40.48 26.77L40.39 37.69L27.72 44.78L27.63 44.62L27.66 35.32C27.66 35.16 27.8 34.92 27.99 34.8L33.63 31.48C33.82 31.37 34 31.14 34.09 30.89L34.08 30.9Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.27 31.06L34.57 30.25C34.61 30.13 34.7 30.02 34.79 29.97L40.24 26.77C40.24 26.77 40.36 26.73 40.44 26.74C40.54 26.76 40.62 26.85 40.62 26.95C40.62 27.22 40.62 27.82 40.62 27.94L40.59 37.84L27.82 45.03L27.87 35.5C27.87 35.34 27.97 35.08 28.1 35L33.82 31.64C34.01 31.53 34.19 31.3 34.28 31.05L34.27 31.06Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.13 39.09L29.51 46.25C29.51 46.25 29.25 46.92 28.41 46.12C27.67 45.42 27.8 44.74 27.8 44.74L40.58 37.26L42.13 39.09Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M29.23 44.93L38.44 39.53C38.98 39.21 39.42 38.44 39.41 37.81L39.35 29.68C39.35 29.05 38.9 28.79 38.36 29.11L29.15 34.51C28.61 34.83 28.17 35.6 28.18 36.23L28.24 44.36C28.24 44.99 28.69 45.25 29.23 44.93Z",
				fill: "#F8F8F8"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.08 45.25C28.9 45.15 28.85 44.92 28.85 44.6L28.8 36.47C28.8 35.84 29.17 35.15 29.71 34.83L38.92 29.42C39.19 29.26 39.43 29.18 39.61 29.28L39.42 29.18C39.24 29.08 39 29.1 38.73 29.25L29.52 34.65C28.98 34.97 28.54 35.74 28.55 36.37L28.61 44.5C28.61 44.82 28.73 45.04 28.91 45.14L29.1 45.24L29.08 45.25Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.77 45.18L38.98 39.78C39.52 39.46 39.96 38.69 39.95 38.06L39.89 29.93C39.89 29.3 39.44 29.04 38.9 29.36L29.69 34.76C29.15 35.08 28.71 35.85 28.72 36.48L28.78 44.61C28.78 45.24 29.23 45.5 29.77 45.18Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M29.77 45.18L38.98 39.78C39.52 39.46 39.96 38.69 39.95 38.06L39.89 29.93C39.89 29.74 39.85 29.59 39.78 29.47C39.61 29.42 39.41 29.46 39.19 29.59L29.98 34.99C29.44 35.31 29 36.08 29.01 36.71L29.07 44.84C29.07 45.03 29.11 45.18 29.18 45.3C29.35 45.35 29.55 45.31 29.77 45.18Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.81 45.74C29.63 45.64 29.58 45.41 29.58 45.09L29.53 36.96C29.53 36.33 29.9 35.64 30.44 35.32L39.65 29.91C39.92 29.75 40.16 29.67 40.34 29.77L40.15 29.67C39.97 29.57 39.73 29.59 39.46 29.74L30.25 35.14C29.71 35.46 29.27 36.23 29.28 36.86L29.34 44.99C29.34 45.31 29.46 45.53 29.64 45.63L29.83 45.73L29.81 45.74Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5 45.66L39.71 40.26C40.25 39.94 40.69 39.17 40.68 38.54L40.62 30.41C40.62 29.78 40.17 29.52 39.63 29.84L30.42 35.24C29.88 35.56 29.44 36.33 29.45 36.96L29.51 45.09C29.51 45.72 29.96 45.98 30.5 45.66Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M39.24 33.1L39.22 31.06C39.22 30.93 39.31 30.78 39.41 30.72C39.52 30.66 39.61 30.71 39.61 30.83L39.63 32.87C39.63 33 39.54 33.15 39.44 33.21C39.33 33.27 39.24 33.22 39.24 33.1Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.26 34.77V34C39.26 33.87 39.34 33.72 39.45 33.66C39.56 33.6 39.65 33.65 39.65 33.77V34.54C39.65 34.67 39.57 34.82 39.46 34.88C39.35 34.94 39.26 34.89 39.26 34.77Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.28 39.59L39.26 35.76C39.26 35.63 39.35 35.48 39.45 35.42C39.56 35.36 39.65 35.41 39.65 35.53L39.67 39.36C39.67 39.49 39.58 39.64 39.48 39.7C39.37 39.76 39.28 39.71 39.28 39.59Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.77 37.46L36.79 41.05C36.79 41.18 36.88 41.23 36.99 41.16C37.1 41.1 37.18 40.94 37.18 40.82L37.16 37.23C37.16 37.1 37.07 37.05 36.96 37.12C36.85 37.18 36.77 37.34 36.77 37.46Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.74 34.06L36.76 36.42C36.76 36.55 36.85 36.6 36.96 36.53C37.07 36.47 37.15 36.31 37.15 36.19L37.13 33.83C37.13 33.7 37.04 33.65 36.93 33.72C36.82 33.78 36.74 33.94 36.74 34.06Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.73 32.52V33.08C36.73 33.21 36.82 33.26 36.93 33.19C37.04 33.13 37.12 32.97 37.12 32.85V32.29C37.12 32.16 37.03 32.11 36.92 32.18C36.81 32.24 36.73 32.4 36.73 32.52Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.45 35.16L38.42 31.53C38.42 31.4 38.51 31.25 38.61 31.19C38.72 31.13 38.81 31.18 38.81 31.3L38.84 34.93C38.84 35.06 38.75 35.21 38.65 35.27C38.54 35.33 38.45 35.28 38.45 35.16Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.65 40.55L37.59 32.02C37.59 31.89 37.68 31.74 37.78 31.68C37.89 31.62 37.98 31.67 37.98 31.79L38.04 40.32C38.04 40.45 37.95 40.6 37.85 40.66C37.74 40.72 37.65 40.67 37.65 40.55Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.96 37.43L34.93 33.58C34.93 33.45 35.02 33.3 35.12 33.24C35.23 33.18 35.32 33.23 35.32 33.35L35.35 37.2C35.35 37.33 35.26 37.48 35.16 37.54C35.05 37.6 34.96 37.55 34.96 37.43Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.48 40.06L38.46 36.51C38.46 36.38 38.55 36.23 38.65 36.17C38.76 36.11 38.85 36.16 38.85 36.28L38.87 39.83C38.87 39.96 38.78 40.11 38.68 40.17C38.57 40.23 38.48 40.18 38.48 40.06Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.46 40L32.48 43.59C32.48 43.72 32.57 43.77 32.68 43.7C32.79 43.64 32.87 43.48 32.87 43.36L32.85 39.77C32.85 39.64 32.76 39.59 32.65 39.66C32.54 39.72 32.46 39.88 32.46 40Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.43 36.59L32.45 38.95C32.45 39.08 32.54 39.13 32.65 39.06C32.76 39 32.84 38.84 32.84 38.72L32.82 36.36C32.82 36.23 32.73 36.18 32.62 36.25C32.51 36.31 32.43 36.47 32.43 36.59Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M32.42 35.06V35.62C32.42 35.75 32.51 35.8 32.62 35.73C32.73 35.67 32.81 35.51 32.81 35.39V34.83C32.81 34.7 32.72 34.65 32.61 34.72C32.5 34.78 32.42 34.94 32.42 35.06Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.14 37.69L34.11 34.06C34.11 33.93 34.2 33.78 34.3 33.72C34.41 33.66 34.5 33.71 34.5 33.83L34.53 37.46C34.53 37.59 34.44 37.74 34.34 37.8C34.23 37.86 34.14 37.81 34.14 37.69Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.33 43.09L33.27 34.56C33.27 34.43 33.36 34.28 33.46 34.22C33.57 34.16 33.66 34.21 33.66 34.33L33.72 42.86C33.72 42.99 33.63 43.14 33.53 43.2C33.42 43.26 33.33 43.21 33.33 43.09Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.17 42.6L34.15 39.05C34.15 38.92 34.24 38.77 34.34 38.71C34.45 38.65 34.54 38.7 34.54 38.82L34.56 42.37C34.56 42.5 34.47 42.65 34.37 42.71C34.26 42.77 34.17 42.72 34.17 42.6Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.89 36.96L35.92 41.56C35.92 41.69 36.01 41.74 36.12 41.67C36.23 41.61 36.31 41.45 36.31 41.33L36.28 36.73C36.28 36.6 36.19 36.55 36.08 36.62C35.97 36.68 35.89 36.84 35.89 36.96Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.86 33.04L35.88 35.62C35.88 35.75 35.97 35.8 36.08 35.73C36.19 35.67 36.27 35.51 36.27 35.39L36.25 32.81C36.25 32.68 36.16 32.63 36.05 32.7C35.94 32.76 35.86 32.92 35.86 33.04Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.57 40.14L30.54 36.29C30.54 36.16 30.63 36.01 30.73 35.95C30.84 35.89 30.93 35.94 30.93 36.06L30.96 39.91C30.96 40.04 30.87 40.19 30.77 40.25C30.66 40.31 30.57 40.26 30.57 40.14Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.49 39.67L31.52 44.27C31.52 44.4 31.61 44.45 31.72 44.38C31.83 44.32 31.91 44.16 31.91 44.04L31.88 39.44C31.88 39.31 31.79 39.26 31.68 39.33C31.57 39.39 31.49 39.55 31.49 39.67Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.46 35.74L31.48 38.32C31.48 38.45 31.57 38.5 31.68 38.43C31.79 38.37 31.87 38.21 31.87 38.09L31.85 35.51C31.85 35.38 31.76 35.33 31.65 35.4C31.54 35.46 31.46 35.62 31.46 35.74Z",
					fill: "#AFC7FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.53 45.69C29.66 45.69 29.8 45.65 29.96 45.56L38.87 40.42C39.09 40.29 39.3 40.08 39.46 39.84L29.54 45.69H29.53Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M40.64 37.24V30.87L40.12 31.17L36.01 33.64C35.83 33.7 35.52 32.76 35.21 32.91L29.92 36.01C29.51 36.28 29.48 36.63 29.48 36.79L29.52 44.25C29.52 44.25 29.51 45.69 29.53 45.69L39.78 39.65L40.64 37.23V37.24Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.18 34.05L42.28 30.44C42.34 30.41 42.39 30.4 42.44 30.41C42.49 30.43 42.67 30.52 42.68 30.52L42.17 38.7L29.71 45.9L29.49 45.69L29.76 36.98C29.76 36.76 29.94 36.5 30.08 36.42L35.58 33.1C35.65 33.06 35.7 33.04 35.73 33.05C35.8 33.07 36.02 33.25 36.02 33.25C36.15 33.57 36.07 34 36.19 34.04L36.18 34.05Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.62 34.1L42.59 30.52C42.59 30.52 42.7 30.52 42.7 30.58L42.45 38.8C42.45 38.9 42.39 38.99 42.31 39.03L29.45 46.52L29.71 45.83L29.98 37.03C29.98 36.87 30.09 36.67 30.23 36.59L35.95 33.23C36.14 33.12 36.45 34.14 36.63 34.08L36.62 34.1Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7 45.85C29.7 47.39 27.69 46.52 27.62 44.62C27.65 44.64 27.77 44.71 27.8 44.72C27.8 46.12 29.4 47.04 29.47 45.69C29.5 45.71 29.66 45.82 29.69 45.84L29.7 45.85Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M37.26 29.11C36.97 29.28 35.87 29.91 35.58 30.08C35.43 30.16 35.43 29.94 35.58 29.86C35.87 29.69 36.97 29.06 37.26 28.89C37.41 28.81 37.41 29.03 37.26 29.11Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.57 28.72C37.99 29.06 36.15 30.12 35.57 30.46C35.42 30.54 35.42 30.32 35.57 30.24C36.15 29.9 37.99 28.84 38.57 28.5C38.72 28.42 38.72 28.64 38.57 28.72Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.63 28.32C38.04 28.66 38.25 28.54 37.66 28.88C37.51 28.96 37.51 28.74 37.66 28.66C38.25 28.32 38.04 28.44 38.63 28.1C38.78 28.02 38.78 28.24 38.63 28.32Z",
					fill: "#F8F8F8"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.23 33L37.53 32.19C37.57 32.07 37.66 31.96 37.75 31.91L43.14 28.74C43.2 28.7 43.26 28.7 43.3 28.72C43.32 28.72 43.63 28.87 43.63 28.87L43.54 39.79L30.87 46.88L30.78 46.72L30.81 37.42C30.81 37.26 30.95 37.02 31.14 36.9L36.78 33.58C36.97 33.47 37.15 33.24 37.24 32.99L37.23 33Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.41 33.17L37.71 32.36C37.75 32.24 37.84 32.13 37.93 32.08L43.38 28.88C43.38 28.88 43.5 28.84 43.58 28.85C43.68 28.87 43.76 28.96 43.76 29.06C43.76 29.33 43.76 29.93 43.76 30.05L43.73 39.95L30.96 47.14L31.01 37.61C31.01 37.45 31.11 37.19 31.24 37.11L36.96 33.75C37.15 33.64 37.33 33.41 37.42 33.16L37.41 33.17Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.28 41.2L32.66 48.36C32.66 48.36 32.4 49.03 31.56 48.23C30.82 47.53 30.95 46.85 30.95 46.85L43.73 39.37L45.28 41.2Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M32.38 47.04L41.59 41.64C42.13 41.32 42.57 40.55 42.56 39.92L42.5 31.79C42.5 31.16 42.05 30.9 41.51 31.22L32.3 36.62C31.76 36.94 31.32 37.71 31.33 38.34L31.39 46.47C31.39 47.1 31.84 47.36 32.38 47.04Z",
				fill: "#F8F8F8"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.22 47.36C32.04 47.26 31.99 47.03 31.99 46.71L31.94 38.58C31.94 37.95 32.31 37.26 32.85 36.94L42.06 31.53C42.33 31.37 42.57 31.29 42.75 31.39L42.56 31.29C42.38 31.19 42.14 31.21 41.87 31.36L32.66 36.76C32.12 37.08 31.68 37.85 31.69 38.48L31.75 46.61C31.75 46.93 31.87 47.15 32.05 47.25L32.24 47.35L32.22 47.36Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.92 47.29L42.13 41.89C42.67 41.57 43.11 40.8 43.1 40.17L43.04 32.04C43.04 31.41 42.59 31.15 42.05 31.47L32.84 36.87C32.3 37.19 31.86 37.96 31.87 38.59L31.93 46.72C31.93 47.35 32.38 47.61 32.92 47.29Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M32.92 47.29L42.13 41.89C42.67 41.57 43.11 40.8 43.1 40.17L43.04 32.04C43.04 31.85 43 31.7 42.93 31.58C42.76 31.53 42.56 31.57 42.34 31.7L33.13 37.1C32.59 37.42 32.15 38.19 32.16 38.82L32.22 46.95C32.22 47.14 32.26 47.29 32.33 47.41C32.5 47.46 32.7 47.42 32.92 47.29Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.95 47.84C32.77 47.74 32.72 47.51 32.72 47.19L32.67 39.06C32.67 38.43 33.04 37.74 33.58 37.42L42.79 32.01C43.06 31.85 43.3 31.77 43.48 31.87L43.29 31.77C43.11 31.67 42.87 31.69 42.6 31.84L33.39 37.24C32.85 37.56 32.41 38.33 32.42 38.96L32.48 47.09C32.48 47.41 32.6 47.63 32.78 47.73L32.97 47.83L32.95 47.84Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.65 47.77L42.86 42.37C43.4 42.05 43.84 41.28 43.83 40.65L43.77 32.52C43.77 31.89 43.32 31.63 42.78 31.95L33.57 37.35C33.03 37.67 32.59 38.44 32.6 39.07L32.66 47.2C32.66 47.83 33.11 48.09 33.65 47.77Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M42.38 35.21L42.36 33.17C42.36 33.04 42.45 32.89 42.55 32.83C42.66 32.77 42.75 32.82 42.75 32.94L42.77 34.98C42.77 35.11 42.68 35.26 42.58 35.32C42.47 35.38 42.38 35.33 42.38 35.21Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.4 36.88V36.11C42.4 35.98 42.48 35.83 42.59 35.77C42.7 35.71 42.79 35.76 42.79 35.88V36.65C42.79 36.78 42.71 36.93 42.6 36.99C42.49 37.05 42.4 37 42.4 36.88Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.43 41.7L42.41 37.87C42.41 37.74 42.5 37.59 42.6 37.53C42.71 37.47 42.8 37.52 42.8 37.64L42.82 41.47C42.82 41.6 42.73 41.75 42.63 41.81C42.52 41.87 42.43 41.82 42.43 41.7Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.91 39.57L39.93 43.16C39.93 43.29 40.02 43.34 40.13 43.27C40.24 43.21 40.32 43.05 40.32 42.93L40.3 39.34C40.3 39.21 40.21 39.16 40.1 39.23C39.99 39.29 39.91 39.45 39.91 39.57Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.89 36.16L39.91 38.52C39.91 38.65 40 38.7 40.11 38.63C40.22 38.57 40.3 38.41 40.3 38.29L40.28 35.93C40.28 35.8 40.19 35.75 40.08 35.82C39.97 35.88 39.89 36.04 39.89 36.16Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.88 34.63V35.19C39.88 35.32 39.97 35.37 40.08 35.3C40.19 35.24 40.27 35.08 40.27 34.96V34.4C40.27 34.27 40.18 34.22 40.07 34.29C39.96 34.35 39.88 34.51 39.88 34.63Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.6 37.26L41.57 33.63C41.57 33.5 41.66 33.35 41.76 33.29C41.87 33.23 41.96 33.28 41.96 33.4L41.99 37.03C41.99 37.16 41.9 37.31 41.8 37.37C41.69 37.43 41.6 37.38 41.6 37.26Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.79 42.66L40.73 34.13C40.73 34 40.82 33.85 40.92 33.79C41.03 33.73 41.12 33.78 41.12 33.9L41.18 42.43C41.18 42.56 41.09 42.71 40.99 42.77C40.88 42.83 40.79 42.78 40.79 42.66Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.11 39.54L38.08 35.69C38.08 35.56 38.17 35.41 38.27 35.35C38.38 35.29 38.47 35.34 38.47 35.46L38.5 39.31C38.5 39.44 38.41 39.59 38.31 39.65C38.2 39.71 38.11 39.66 38.11 39.54Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.63 42.17L41.61 38.62C41.61 38.49 41.7 38.34 41.8 38.28C41.91 38.22 42 38.27 42 38.39L42.02 41.94C42.02 42.07 41.93 42.22 41.83 42.28C41.72 42.34 41.63 42.29 41.63 42.17Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.6 42.11L35.62 45.7C35.62 45.83 35.71 45.88 35.82 45.81C35.93 45.75 36.01 45.59 36.01 45.47L35.99 41.88C35.99 41.75 35.9 41.7 35.79 41.77C35.68 41.83 35.6 41.99 35.6 42.11Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.57 38.7L35.59 41.06C35.59 41.19 35.68 41.24 35.79 41.17C35.9 41.11 35.98 40.95 35.98 40.83L35.96 38.47C35.96 38.34 35.87 38.29 35.76 38.36C35.65 38.42 35.57 38.58 35.57 38.7Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M35.56 37.16V37.72C35.56 37.85 35.65 37.9 35.76 37.83C35.87 37.77 35.95 37.61 35.95 37.49V36.93C35.95 36.8 35.86 36.75 35.75 36.82C35.64 36.88 35.56 37.04 35.56 37.16Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.28 39.8L37.25 36.17C37.25 36.04 37.34 35.89 37.44 35.83C37.55 35.77 37.64 35.82 37.64 35.94L37.67 39.57C37.67 39.7 37.58 39.85 37.48 39.91C37.37 39.97 37.28 39.92 37.28 39.8Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.48 45.19L36.42 36.66C36.42 36.53 36.51 36.38 36.61 36.32C36.72 36.26 36.81 36.31 36.81 36.43L36.87 44.96C36.87 45.09 36.78 45.24 36.68 45.3C36.57 45.36 36.48 45.31 36.48 45.19Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.31 44.7L37.29 41.15C37.29 41.02 37.38 40.87 37.48 40.81C37.59 40.75 37.68 40.8 37.68 40.92L37.7 44.47C37.7 44.6 37.61 44.75 37.51 44.81C37.4 44.87 37.31 44.82 37.31 44.7Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.03 39.07L39.06 43.67C39.06 43.8 39.15 43.85 39.26 43.78C39.37 43.72 39.45 43.56 39.45 43.44L39.42 38.84C39.42 38.71 39.33 38.66 39.22 38.73C39.11 38.79 39.03 38.95 39.03 39.07Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39 35.14L39.02 37.72C39.02 37.85 39.11 37.9 39.22 37.83C39.33 37.77 39.41 37.61 39.41 37.49L39.39 34.91C39.39 34.78 39.3 34.73 39.19 34.8C39.08 34.86 39 35.02 39 35.14Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.71 42.25L33.68 38.4C33.68 38.27 33.77 38.12 33.87 38.06C33.98 38 34.07 38.05 34.07 38.17L34.1 42.02C34.1 42.15 34.01 42.3 33.91 42.36C33.8 42.42 33.71 42.37 33.71 42.25Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.64 41.78L34.67 46.38C34.67 46.51 34.76 46.56 34.87 46.49C34.98 46.43 35.06 46.27 35.06 46.15L35.03 41.55C35.03 41.42 34.94 41.37 34.83 41.44C34.72 41.5 34.64 41.66 34.64 41.78Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M34.61 37.85L34.63 40.43C34.63 40.56 34.72 40.61 34.83 40.54C34.94 40.48 35.02 40.32 35.02 40.2L35 37.62C35 37.49 34.91 37.44 34.8 37.51C34.69 37.57 34.61 37.73 34.61 37.85Z",
					fill: "#AFC7FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.68 47.8C32.81 47.8 32.95 47.76 33.11 47.67L42.02 42.53C42.24 42.4 42.45 42.19 42.61 41.95L32.69 47.8H32.68Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M43.78 39.34V32.97L43.26 33.27L39.15 35.74C38.97 35.8 38.66 34.86 38.35 35.01L33.06 38.11C32.65 38.38 32.62 38.73 32.62 38.89L32.66 46.35C32.66 46.35 32.65 47.79 32.67 47.79L42.92 41.75L43.78 39.33V39.34Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.32 36.15L45.42 32.54C45.48 32.51 45.53 32.5 45.58 32.51C45.63 32.53 45.81 32.62 45.82 32.62L45.31 40.8L32.85 48L32.63 47.79L32.9 39.08C32.9 38.86 33.08 38.6 33.22 38.52L38.72 35.2C38.79 35.16 38.84 35.14 38.87 35.15C38.94 35.17 39.16 35.35 39.16 35.35C39.29 35.67 39.21 36.1 39.33 36.14L39.32 36.15Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.77 36.2L45.74 32.62C45.74 32.62 45.85 32.62 45.85 32.68L45.6 40.9C45.6 41 45.54 41.09 45.46 41.13L32.6 48.62L32.86 47.93L33.13 39.13C33.13 38.97 33.24 38.77 33.38 38.69L39.1 35.33C39.29 35.22 39.6 36.24 39.78 36.18L39.77 36.2Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.85 47.95C32.85 49.49 30.84 48.62 30.77 46.72C30.8 46.74 30.92 46.81 30.95 46.82C30.95 48.22 32.55 49.14 32.62 47.79C32.65 47.81 32.81 47.92 32.84 47.94L32.85 47.95Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M40.4 31.22C40.11 31.39 39.01 32.02 38.72 32.19C38.57 32.27 38.57 32.05 38.72 31.97C39.01 31.8 40.11 31.17 40.4 31C40.55 30.92 40.55 31.14 40.4 31.22Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.72 30.83C41.14 31.17 39.3 32.23 38.72 32.57C38.57 32.65 38.57 32.43 38.72 32.35C39.3 32.01 41.14 30.95 41.72 30.61C41.87 30.53 41.87 30.75 41.72 30.83Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.77 30.43C41.18 30.77 41.39 30.65 40.8 30.99C40.65 31.07 40.65 30.85 40.8 30.77C41.39 30.43 41.18 30.55 41.77 30.21C41.92 30.13 41.92 30.35 41.77 30.43Z",
					fill: "#F8F8F8"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.36 35.03L40.66 34.22C40.7 34.1 40.79 33.99 40.88 33.94L46.27 30.77C46.33 30.73 46.39 30.73 46.43 30.75C46.45 30.75 46.76 30.9 46.76 30.9L46.67 41.82L34 48.91L33.91 48.75L33.94 39.45C33.94 39.29 34.08 39.05 34.27 38.93L39.91 35.61C40.1 35.5 40.28 35.27 40.37 35.02L40.36 35.03Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.54 35.2L40.84 34.39C40.88 34.27 40.97 34.16 41.06 34.11L46.51 30.91C46.51 30.91 46.63 30.87 46.71 30.88C46.81 30.9 46.89 30.99 46.89 31.09C46.89 31.36 46.89 31.96 46.89 32.08L46.86 41.98L34.09 49.17L34.14 39.64C34.14 39.48 34.24 39.22 34.37 39.14L40.09 35.78C40.28 35.67 40.46 35.44 40.55 35.19L40.54 35.2Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.41 43.23L35.79 50.39C35.79 50.39 35.53 51.06 34.69 50.26C33.95 49.56 34.08 48.88 34.08 48.88L46.86 41.4L48.41 43.23Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M35.51 49.07L44.72 43.67C45.26 43.35 45.7 42.58 45.69 41.95L45.63 33.82C45.63 33.19 45.18 32.93 44.64 33.25L35.43 38.65C34.89 38.97 34.45 39.74 34.46 40.37L34.52 48.5C34.52 49.13 34.97 49.39 35.51 49.07Z",
				fill: "#F8F8F8"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.35 49.39C35.17 49.29 35.12 49.06 35.12 48.74L35.07 40.61C35.07 39.98 35.44 39.29 35.98 38.97L45.19 33.56C45.46 33.4 45.7 33.32 45.88 33.42L45.69 33.32C45.51 33.22 45.27 33.24 45 33.39L35.79 38.79C35.25 39.11 34.81 39.88 34.82 40.51L34.88 48.64C34.88 48.96 35 49.18 35.18 49.28L35.37 49.38L35.35 49.39Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.05 49.32L45.26 43.92C45.8 43.6 46.24 42.83 46.23 42.2L46.17 34.07C46.17 33.44 45.72 33.18 45.18 33.5L35.97 38.9C35.43 39.22 34.99 39.99 35 40.62L35.06 48.75C35.06 49.38 35.51 49.64 36.05 49.32Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M36.05 49.32L45.26 43.92C45.8 43.6 46.24 42.83 46.23 42.2L46.17 34.07C46.17 33.88 46.13 33.73 46.06 33.61C45.89 33.56 45.69 33.6 45.47 33.73L36.26 39.13C35.72 39.45 35.28 40.22 35.29 40.85L35.35 48.98C35.35 49.17 35.39 49.32 35.46 49.44C35.63 49.49 35.83 49.45 36.05 49.32Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.09 49.87C35.91 49.77 35.86 49.54 35.86 49.22L35.81 41.09C35.81 40.46 36.18 39.77 36.72 39.45L45.93 34.04C46.2 33.88 46.44 33.8 46.62 33.9L46.43 33.8C46.25 33.7 46.01 33.72 45.74 33.87L36.53 39.27C35.99 39.59 35.55 40.36 35.56 40.99L35.62 49.12C35.62 49.44 35.74 49.66 35.92 49.76L36.11 49.86L36.09 49.87Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.78 49.8L45.99 44.4C46.53 44.08 46.97 43.31 46.96 42.68L46.9 34.55C46.9 33.92 46.45 33.66 45.91 33.98L36.7 39.38C36.16 39.7 35.72 40.47 35.73 41.1L35.79 49.23C35.79 49.86 36.24 50.12 36.78 49.8Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M45.52 37.24L45.5 35.2C45.5 35.07 45.59 34.92 45.69 34.86C45.8 34.8 45.89 34.85 45.89 34.97L45.91 37.01C45.91 37.14 45.82 37.29 45.72 37.35C45.61 37.41 45.52 37.36 45.52 37.24Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.54 38.91V38.14C45.54 38.01 45.62 37.86 45.73 37.8C45.84 37.74 45.93 37.79 45.93 37.91V38.68C45.93 38.81 45.85 38.96 45.74 39.02C45.63 39.08 45.54 39.03 45.54 38.91Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.56 43.73L45.54 39.9C45.54 39.77 45.63 39.62 45.73 39.56C45.84 39.5 45.93 39.55 45.93 39.67L45.95 43.5C45.95 43.63 45.86 43.78 45.76 43.84C45.65 43.9 45.56 43.85 45.56 43.73Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.05 41.6L43.07 45.19C43.07 45.32 43.16 45.37 43.27 45.3C43.38 45.24 43.46 45.08 43.46 44.96L43.44 41.37C43.44 41.24 43.35 41.19 43.24 41.26C43.13 41.32 43.05 41.48 43.05 41.6Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.02 38.2L43.04 40.56C43.04 40.69 43.13 40.74 43.24 40.67C43.35 40.61 43.43 40.45 43.43 40.33L43.41 37.97C43.41 37.84 43.32 37.79 43.21 37.86C43.1 37.92 43.02 38.08 43.02 38.2Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.01 36.66V37.22C43.01 37.35 43.1 37.4 43.21 37.33C43.32 37.27 43.4 37.11 43.4 36.99V36.43C43.4 36.3 43.31 36.25 43.2 36.32C43.09 36.38 43.01 36.54 43.01 36.66Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.73 39.3L44.7 35.67C44.7 35.54 44.79 35.39 44.89 35.33C45 35.27 45.09 35.32 45.09 35.44L45.12 39.07C45.12 39.2 45.03 39.35 44.93 39.41C44.82 39.47 44.73 39.42 44.73 39.3Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.92 44.69L43.86 36.16C43.86 36.03 43.95 35.88 44.05 35.82C44.16 35.76 44.25 35.81 44.25 35.93L44.31 44.46C44.31 44.59 44.22 44.74 44.12 44.8C44.01 44.86 43.92 44.81 43.92 44.69Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.24 41.57L41.21 37.72C41.21 37.59 41.3 37.44 41.4 37.38C41.51 37.32 41.6 37.37 41.6 37.49L41.63 41.34C41.63 41.47 41.54 41.62 41.44 41.68C41.33 41.74 41.24 41.69 41.24 41.57Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.76 44.2L44.74 40.65C44.74 40.52 44.83 40.37 44.93 40.31C45.04 40.25 45.13 40.3 45.13 40.42L45.15 43.97C45.15 44.1 45.06 44.25 44.96 44.31C44.85 44.37 44.76 44.32 44.76 44.2Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.73 44.14L38.75 47.73C38.75 47.86 38.84 47.91 38.95 47.84C39.06 47.78 39.14 47.62 39.14 47.5L39.12 43.91C39.12 43.78 39.03 43.73 38.92 43.8C38.81 43.86 38.73 44.02 38.73 44.14Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.71 40.73L38.73 43.09C38.73 43.22 38.82 43.27 38.93 43.2C39.04 43.14 39.12 42.98 39.12 42.86L39.1 40.5C39.1 40.37 39.01 40.32 38.9 40.39C38.79 40.45 38.71 40.61 38.71 40.73Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.69 39.19V39.75C38.69 39.88 38.78 39.93 38.89 39.86C39 39.8 39.08 39.64 39.08 39.52V38.96C39.08 38.83 38.99 38.78 38.88 38.85C38.77 38.91 38.69 39.07 38.69 39.19Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.41 41.83L40.38 38.2C40.38 38.07 40.47 37.92 40.57 37.86C40.68 37.8 40.77 37.85 40.77 37.97L40.8 41.6C40.8 41.73 40.71 41.88 40.61 41.94C40.5 42 40.41 41.95 40.41 41.83Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.61 47.22L39.55 38.69C39.55 38.56 39.64 38.41 39.74 38.35C39.85 38.29 39.94 38.34 39.94 38.46L40 46.99C40 47.12 39.91 47.27 39.81 47.33C39.7 47.39 39.61 47.34 39.61 47.22Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.45 46.73L40.43 43.18C40.43 43.05 40.52 42.9 40.62 42.84C40.73 42.78 40.82 42.83 40.82 42.95L40.84 46.5C40.84 46.63 40.75 46.78 40.65 46.84C40.55 46.9 40.45 46.85 40.45 46.73Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.17 41.1L42.2 45.7C42.2 45.83 42.29 45.88 42.4 45.81C42.51 45.75 42.59 45.59 42.59 45.47L42.56 40.87C42.56 40.74 42.47 40.69 42.36 40.76C42.25 40.82 42.17 40.98 42.17 41.1Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.14 37.17L42.16 39.75C42.16 39.88 42.25 39.93 42.36 39.86C42.47 39.8 42.55 39.64 42.55 39.52L42.53 36.94C42.53 36.81 42.44 36.76 42.33 36.83C42.22 36.89 42.14 37.05 42.14 37.17Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.84 44.28L36.81 40.43C36.81 40.3 36.9 40.15 37 40.09C37.11 40.03 37.2 40.08 37.2 40.2L37.23 44.05C37.23 44.18 37.14 44.33 37.04 44.39C36.93 44.45 36.84 44.4 36.84 44.28Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.77 43.81L37.8 48.41C37.8 48.54 37.89 48.59 38 48.52C38.11 48.46 38.19 48.3 38.19 48.18L38.16 43.58C38.16 43.45 38.07 43.4 37.96 43.47C37.85 43.53 37.77 43.69 37.77 43.81Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37.74 39.88L37.76 42.46C37.76 42.59 37.85 42.64 37.96 42.57C38.07 42.51 38.15 42.35 38.15 42.23L38.13 39.65C38.13 39.52 38.04 39.47 37.93 39.54C37.82 39.6 37.74 39.76 37.74 39.88Z",
					fill: "#AFC7FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.81 49.83C35.94 49.83 36.08 49.79 36.24 49.7L45.15 44.56C45.37 44.43 45.58 44.22 45.74 43.98L35.82 49.83H35.81Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M46.91 41.37V35L46.39 35.3L42.28 37.77C42.1 37.83 41.79 36.89 41.48 37.04L36.19 40.14C35.78 40.41 35.75 40.76 35.75 40.92L35.79 48.38C35.79 48.38 35.78 49.82 35.8 49.82L46.05 43.78L46.91 41.36V41.37Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.46 38.18L48.56 34.57C48.62 34.54 48.67 34.53 48.72 34.54C48.77 34.56 48.95 34.65 48.96 34.65L48.45 42.83L35.99 50.03L35.77 49.82L36.04 41.11C36.04 40.89 36.22 40.63 36.36 40.55L41.86 37.23C41.93 37.19 41.98 37.17 42.01 37.18C42.08 37.2 42.3 37.38 42.3 37.38C42.43 37.7 42.35 38.13 42.47 38.17L42.46 38.18Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.9 38.24L48.87 34.66C48.87 34.66 48.98 34.66 48.98 34.72L48.73 42.94C48.73 43.04 48.67 43.13 48.59 43.17L35.73 50.66L35.99 49.97L36.26 41.17C36.26 41.01 36.37 40.81 36.51 40.73L42.23 37.37C42.42 37.26 42.73 38.28 42.91 38.22L42.9 38.24Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.98 49.98C35.98 51.52 33.97 50.65 33.9 48.75C33.93 48.77 34.05 48.84 34.08 48.85C34.08 50.25 35.68 51.17 35.75 49.82C35.78 49.84 35.94 49.95 35.97 49.97L35.98 49.98Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M43.53 33.25C43.24 33.42 42.14 34.05 41.85 34.22C41.7 34.3 41.7 34.08 41.85 34C42.14 33.83 43.24 33.2 43.53 33.03C43.68 32.95 43.68 33.17 43.53 33.25Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.85 32.86C44.27 33.2 42.43 34.26 41.85 34.6C41.7 34.68 41.7 34.46 41.85 34.38C42.43 34.04 44.27 32.98 44.85 32.64C45 32.56 45 32.78 44.85 32.86Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.9 32.46C44.31 32.8 44.52 32.68 43.93 33.02C43.78 33.1 43.78 32.88 43.93 32.8C44.52 32.46 44.31 32.58 44.9 32.24C45.05 32.16 45.05 32.38 44.9 32.46Z",
					fill: "#F8F8F8"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.51 36.86L43.81 36.05C43.85 35.93 43.94 35.82 44.03 35.77L49.42 32.6C49.48 32.56 49.54 32.56 49.58 32.58C49.6 32.58 49.91 32.73 49.91 32.73L49.82 43.65L37.15 50.74L37.06 50.58L37.09 41.28C37.09 41.12 37.23 40.88 37.42 40.76L43.06 37.44C43.25 37.33 43.43 37.1 43.52 36.85L43.51 36.86Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.69 37.03L43.99 36.22C44.03 36.1 44.12 35.99 44.21 35.94L49.66 32.74C49.66 32.74 49.78 32.7 49.86 32.71C49.96 32.73 50.04 32.82 50.04 32.92C50.04 33.19 50.04 33.79 50.04 33.91L50.01 43.81L37.24 51L37.29 41.44C37.29 41.28 37.38 41.05 37.52 40.97L43.24 37.61C43.43 37.5 43.61 37.27 43.7 37.02L43.69 37.03Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.56 45.06L38.94 52.22C38.94 52.22 38.68 52.89 37.84 52.09C37.1 51.39 37.23 50.71 37.23 50.71L50.01 43.23L51.56 45.06Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M38.74 51.6L48.33 45.63C48.9 45.3 49.35 44.49 49.35 43.83L49.29 35.33C49.29 35.13 49.25 34.97 49.17 34.85C49 34.8 48.78 34.84 48.55 34.97L38.92 40.62C38.35 40.95 37.9 41.76 37.9 42.42L37.96 50.92C37.96 51.12 38 51.28 38.08 51.4C38.37 51.67 38.51 51.74 38.74 51.6Z",
				fill: "#F8F8F8"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.73 51.85C38.54 51.74 38.49 51.5 38.48 51.17L38.42 42.67C38.42 42.01 38.8 41.28 39.37 40.95L49.01 35.29C49.29 35.13 49.54 35.04 49.73 35.15L49.53 35.04C49.34 34.93 49.09 34.95 48.8 35.12L39.17 40.77C38.6 41.1 38.15 41.91 38.15 42.57L38.21 51.07C38.21 51.4 38.33 51.64 38.52 51.74L38.72 51.85H38.73Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.46 51.78L49.09 46.13C49.66 45.8 50.11 44.99 50.11 44.33L50.05 35.83C50.05 35.17 49.58 34.9 49.01 35.23L39.38 40.88C38.81 41.21 38.36 42.02 38.36 42.68L38.42 51.18C38.42 51.84 38.89 52.11 39.46 51.78Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M48.6 38.64L48.58 36.5C48.58 36.37 48.67 36.21 48.78 36.14C48.89 36.07 48.99 36.13 48.99 36.26L49.01 38.4C49.01 38.53 48.92 38.69 48.81 38.76C48.7 38.83 48.6 38.77 48.6 38.64Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M48.62 40.38V39.57C48.62 39.44 48.7 39.28 48.82 39.21C48.93 39.14 49.03 39.2 49.03 39.33V40.14C49.03 40.27 48.95 40.43 48.83 40.5C48.72 40.57 48.62 40.51 48.62 40.38Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M48.64 45.42L48.62 41.41C48.62 41.28 48.71 41.12 48.82 41.05C48.93 40.98 49.03 41.04 49.03 41.17L49.05 45.18C49.05 45.31 48.96 45.47 48.85 45.54C48.74 45.61 48.64 45.55 48.64 45.42Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.02 43.2L46.04 46.96C46.04 47.09 46.13 47.14 46.25 47.08C46.36 47.01 46.45 46.85 46.45 46.72L46.43 42.96C46.43 42.83 46.34 42.78 46.22 42.84C46.11 42.91 46.02 43.07 46.02 43.2Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.99 39.64L46.01 42.11C46.01 42.24 46.1 42.29 46.22 42.23C46.33 42.16 46.42 42 46.42 41.87L46.4 39.4C46.4 39.27 46.31 39.22 46.19 39.28C46.08 39.35 45.99 39.51 45.99 39.64Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.97 38.03V38.61C45.97 38.74 46.06 38.8 46.18 38.73C46.29 38.66 46.38 38.5 46.38 38.37V37.79C46.38 37.66 46.29 37.6 46.17 37.67C46.06 37.74 45.97 37.9 45.97 38.03Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.78 40.79L47.75 36.99C47.75 36.86 47.84 36.7 47.95 36.63C48.06 36.56 48.16 36.62 48.16 36.75L48.19 40.55C48.19 40.68 48.1 40.84 47.99 40.91C47.88 40.98 47.78 40.92 47.78 40.79Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.93 46.43L46.87 37.5C46.87 37.37 46.96 37.21 47.07 37.14C47.18 37.07 47.28 37.13 47.28 37.26L47.34 46.19C47.34 46.32 47.25 46.48 47.14 46.55C47.03 46.62 46.93 46.56 46.93 46.43Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.13 43.17L44.1 39.14C44.1 39.01 44.19 38.85 44.3 38.78C44.41 38.71 44.51 38.77 44.51 38.9L44.54 42.93C44.54 43.06 44.45 43.22 44.34 43.29C44.23 43.36 44.13 43.3 44.13 43.17Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.81 45.92L47.79 42.2C47.79 42.07 47.88 41.91 47.99 41.84C48.1 41.77 48.2 41.83 48.2 41.96L48.22 45.68C48.22 45.81 48.13 45.97 48.02 46.04C47.91 46.11 47.81 46.05 47.81 45.92Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.5 45.85L41.52 49.61C41.52 49.74 41.61 49.79 41.73 49.73C41.84 49.66 41.93 49.5 41.93 49.37L41.91 45.61C41.91 45.48 41.82 45.43 41.7 45.49C41.59 45.56 41.5 45.72 41.5 45.85Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.47 42.29L41.49 44.76C41.49 44.89 41.58 44.94 41.7 44.88C41.81 44.81 41.9 44.65 41.9 44.52L41.88 42.05C41.88 41.92 41.79 41.87 41.67 41.93C41.56 42 41.47 42.16 41.47 42.29Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.46 40.68V41.26C41.46 41.39 41.55 41.45 41.67 41.38C41.78 41.31 41.87 41.15 41.87 41.02V40.44C41.87 40.31 41.78 40.25 41.66 40.32C41.55 40.39 41.46 40.55 41.46 40.68Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.26 43.44L43.23 39.64C43.23 39.51 43.32 39.35 43.43 39.28C43.54 39.21 43.64 39.27 43.64 39.4L43.67 43.2C43.67 43.33 43.58 43.49 43.47 43.56C43.36 43.63 43.26 43.57 43.26 43.44Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.42 49.08L42.36 40.15C42.36 40.02 42.45 39.86 42.56 39.79C42.67 39.72 42.77 39.78 42.77 39.91L42.83 48.84C42.83 48.97 42.74 49.13 42.63 49.2C42.52 49.27 42.42 49.21 42.42 49.08Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M43.29 48.57L43.27 44.85C43.27 44.72 43.36 44.56 43.47 44.49C43.58 44.42 43.68 44.48 43.68 44.61L43.7 48.33C43.7 48.46 43.61 48.62 43.5 48.69C43.39 48.76 43.29 48.7 43.29 48.57Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.09 42.68L45.12 47.5C45.12 47.63 45.21 47.68 45.33 47.62C45.44 47.55 45.53 47.39 45.53 47.26L45.5 42.44C45.5 42.31 45.41 42.26 45.29 42.32C45.18 42.39 45.09 42.55 45.09 42.68Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.06 38.57L45.08 41.27C45.08 41.4 45.17 41.45 45.29 41.39C45.4 41.32 45.49 41.16 45.49 41.03L45.47 38.33C45.47 38.2 45.38 38.15 45.26 38.21C45.15 38.28 45.06 38.44 45.06 38.57Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M39.53 46L39.5 41.97C39.5 41.84 39.59 41.68 39.7 41.61C39.81 41.54 39.91 41.6 39.91 41.73L39.94 45.76C39.94 45.89 39.85 46.05 39.74 46.12C39.63 46.19 39.53 46.13 39.53 46Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.49 45.51L40.52 50.33C40.52 50.46 40.61 50.51 40.73 50.45C40.84 50.38 40.93 50.22 40.93 50.09L40.9 45.27C40.9 45.14 40.81 45.09 40.69 45.15C40.58 45.22 40.49 45.38 40.49 45.51Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M40.46 41.4L40.48 44.1C40.48 44.23 40.57 44.28 40.69 44.22C40.8 44.15 40.89 43.99 40.89 43.86L40.87 41.16C40.87 41.03 40.78 40.98 40.66 41.04C40.55 41.11 40.46 41.27 40.46 41.4Z",
					fill: "#AFC7FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.96 51.66C39.09 51.66 39.23 51.62 39.39 51.53L48.3 46.39C48.52 46.26 48.73 46.05 48.89 45.81L38.97 51.66H38.96Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M50.06 43.2V36.83L49.54 37.13L45.43 39.6C45.25 39.66 44.94 38.72 44.63 38.87L39.34 41.97C38.93 42.24 38.9 42.59 38.9 42.75L38.94 50.21C38.94 50.21 38.93 51.65 38.95 51.65L49.2 45.61L50.06 43.19V43.2Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.61 40.01L51.71 36.4C51.77 36.37 51.82 36.36 51.87 36.37C51.92 36.39 52.1 36.48 52.11 36.48L51.6 44.66L39.14 51.86L38.92 51.65L39.19 42.94C39.19 42.72 39.37 42.46 39.51 42.38L45.01 39.06C45.08 39.02 45.13 39 45.16 39.01C45.23 39.03 45.45 39.21 45.45 39.21C45.58 39.53 45.5 39.96 45.62 40L45.61 40.01Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.05 40.07L52.02 36.49C52.02 36.49 52.13 36.49 52.13 36.55L51.88 44.77C51.88 44.87 51.82 44.96 51.74 45L38.88 52.49L39.14 51.8L39.41 43C39.41 42.84 39.52 42.64 39.66 42.56L45.38 39.2C45.57 39.09 45.88 40.11 46.06 40.05L46.05 40.07Z",
			fill: "#717171"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.13 51.81C39.13 53.35 37.12 52.48 37.05 50.58C37.08 50.6 37.2 50.67 37.23 50.68C37.23 52.08 38.83 53 38.9 51.65C38.93 51.67 39.09 51.78 39.12 51.8L39.13 51.81Z",
			fill: "#555555"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M45.88 35.54C45.59 35.71 45.29 35.88 45 36.05C44.85 36.13 44.85 35.91 45 35.83C45.29 35.66 45.59 35.49 45.88 35.32C46.03 35.24 46.03 35.46 45.88 35.54Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.8 34.8C47.22 35.14 45.58 36.1 45 36.43C44.85 36.51 44.85 36.29 45 36.21C45.58 35.87 47.22 34.91 47.8 34.58C47.95 34.5 47.95 34.72 47.8 34.8Z",
					fill: "#F8F8F8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.69 34.49C47.1 34.83 46.87 34.97 46.28 35.31C46.13 35.39 46.13 35.17 46.28 35.09C46.87 34.75 47.1 34.61 47.69 34.27C47.84 34.19 47.84 34.41 47.69 34.49Z",
					fill: "#F8F8F8"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.2 36.59L48.5 35.78C48.54 35.66 48.63 35.55 48.72 35.5L54.11 32.33C54.17 32.29 54.23 32.29 54.27 32.31C54.29 32.31 54.6 32.46 54.6 32.46L54.51 43.38L41.84 50.47L41.75 50.31L41.78 41.01C41.78 40.85 41.92 40.61 42.11 40.49L47.75 37.17C47.94 37.06 48.12 36.83 48.21 36.58L48.2 36.59Z",
			fill: "#BD1B4B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.39 36.75L48.69 35.94C48.73 35.82 48.82 35.71 48.91 35.66L54.36 32.46C54.36 32.46 54.48 32.42 54.56 32.43C54.66 32.45 54.74 32.54 54.74 32.64C54.74 32.91 54.74 33.51 54.74 33.63L54.71 43.53L41.94 50.72L41.97 41.12C41.97 40.96 42.08 40.76 42.22 40.68L47.94 37.32C48.13 37.21 48.31 36.98 48.4 36.73L48.39 36.75Z",
			fill: "#FF467B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M56.25 44.78L43.63 51.94C43.63 51.94 43.37 52.61 42.53 51.81C41.79 51.11 41.92 50.43 41.92 50.43L54.7 42.95L56.25 44.78Z",
			fill: "#F9C923"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.35 50.62L52.56 45.22C53.1 44.9 53.54 44.13 53.53 43.5L53.47 35.37C53.47 34.74 53.02 34.48 52.48 34.8L43.27 40.2C42.73 40.52 42.29 41.29 42.3 41.92L42.36 50.05C42.36 50.68 42.81 50.94 43.35 50.62Z",
			fill: "#BD1B4B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.2 50.94C43.02 50.84 42.97 50.61 42.97 50.29L42.92 42.16C42.92 41.53 43.29 40.84 43.83 40.52L53.04 35.11C53.31 34.95 53.55 34.87 53.73 34.97L53.54 34.87C53.36 34.77 53.12 34.79 52.85 34.94L43.64 40.34C43.1 40.66 42.66 41.43 42.67 42.06L42.73 50.19C42.73 50.51 42.85 50.73 43.03 50.83L43.22 50.93L43.2 50.94Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.89 50.87L53.1 45.47C53.64 45.15 54.08 44.38 54.07 43.75L54.01 35.62C54.01 34.99 53.56 34.73 53.02 35.05L43.81 40.45C43.27 40.77 42.83 41.54 42.84 42.17L42.9 50.3C42.9 50.93 43.35 51.19 43.89 50.87Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M43.89 50.87L53.1 45.47C53.64 45.15 54.08 44.38 54.07 43.75L54.01 35.62C54.01 35.43 53.97 35.28 53.9 35.16C53.73 35.11 53.53 35.15 53.31 35.28L44.1 40.68C43.56 41 43.12 41.77 43.13 42.4L43.19 50.53C43.19 50.72 43.23 50.87 43.3 50.99C43.47 51.04 43.67 51 43.89 50.87Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.93 51.43C43.75 51.33 43.7 51.1 43.7 50.78L43.65 42.65C43.65 42.02 44.02 41.33 44.56 41.01L53.77 35.6C54.04 35.44 54.28 35.36 54.46 35.46L54.27 35.36C54.09 35.26 53.85 35.28 53.58 35.43L44.37 40.83C43.83 41.15 43.39 41.92 43.4 42.55L43.46 50.68C43.46 51 43.58 51.22 43.76 51.32L43.95 51.42L43.93 51.43Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.62 51.35L53.83 45.95C54.37 45.63 54.81 44.86 54.8 44.23L54.74 36.1C54.74 35.47 54.29 35.21 53.75 35.53L44.54 40.93C44 41.25 43.56 42.02 43.57 42.65L43.63 50.78C43.63 51.41 44.08 51.67 44.62 51.35Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M53.36 38.79L53.34 36.75C53.34 36.62 53.43 36.47 53.53 36.41C53.64 36.35 53.73 36.4 53.73 36.52L53.75 38.56C53.75 38.69 53.66 38.84 53.56 38.9C53.45 38.96 53.36 38.91 53.36 38.79Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.38 40.46V39.69C53.38 39.56 53.46 39.41 53.57 39.35C53.68 39.29 53.77 39.34 53.77 39.46V40.23C53.77 40.36 53.69 40.51 53.58 40.57C53.47 40.63 53.38 40.58 53.38 40.46Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.4 45.28L53.38 41.45C53.38 41.32 53.47 41.17 53.57 41.11C53.68 41.05 53.77 41.1 53.77 41.22L53.79 45.05C53.79 45.18 53.7 45.33 53.6 45.39C53.49 45.45 53.4 45.4 53.4 45.28Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.89 43.15L50.91 46.74C50.91 46.87 51 46.92 51.11 46.85C51.22 46.79 51.3 46.63 51.3 46.51L51.28 42.92C51.28 42.79 51.19 42.74 51.08 42.81C50.97 42.87 50.89 43.03 50.89 43.15Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.86 39.75L50.88 42.11C50.88 42.24 50.97 42.29 51.08 42.22C51.19 42.16 51.27 42 51.27 41.88L51.25 39.52C51.25 39.39 51.16 39.34 51.05 39.41C50.94 39.47 50.86 39.63 50.86 39.75Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.85 38.21V38.77C50.85 38.9 50.94 38.95 51.05 38.88C51.16 38.82 51.24 38.66 51.24 38.54V37.98C51.24 37.85 51.15 37.8 51.04 37.87C50.93 37.93 50.85 38.09 50.85 38.21Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.57 40.85L52.54 37.22C52.54 37.09 52.63 36.94 52.73 36.88C52.84 36.82 52.93 36.87 52.93 36.99L52.96 40.62C52.96 40.75 52.87 40.9 52.77 40.96C52.66 41.02 52.57 40.97 52.57 40.85Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.77 46.24L51.71 37.71C51.71 37.58 51.8 37.43 51.9 37.37C52.01 37.31 52.1 37.36 52.1 37.48L52.16 46.01C52.16 46.14 52.07 46.29 51.97 46.35C51.86 46.41 51.77 46.36 51.77 46.24Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.08 43.12L49.05 39.27C49.05 39.14 49.14 38.99 49.24 38.93C49.35 38.87 49.44 38.92 49.44 39.04L49.47 42.89C49.47 43.02 49.38 43.17 49.28 43.23C49.17 43.29 49.08 43.24 49.08 43.12Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.6 45.75L52.58 42.2C52.58 42.07 52.67 41.92 52.77 41.86C52.88 41.8 52.97 41.85 52.97 41.97L52.99 45.52C52.99 45.65 52.9 45.8 52.8 45.86C52.69 45.92 52.6 45.87 52.6 45.75Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.58 45.69L46.6 49.28C46.6 49.41 46.69 49.46 46.8 49.39C46.91 49.33 46.99 49.17 46.99 49.05L46.97 45.46C46.97 45.33 46.88 45.28 46.77 45.35C46.66 45.41 46.58 45.57 46.58 45.69Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.55 42.28L46.57 44.64C46.57 44.77 46.66 44.82 46.77 44.75C46.88 44.69 46.96 44.53 46.96 44.41L46.94 42.05C46.94 41.92 46.85 41.87 46.74 41.94C46.63 42 46.55 42.16 46.55 42.28Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M46.54 40.75V41.31C46.54 41.44 46.63 41.49 46.74 41.42C46.85 41.36 46.93 41.2 46.93 41.08V40.52C46.93 40.39 46.84 40.34 46.73 40.41C46.62 40.47 46.54 40.63 46.54 40.75Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M48.26 43.38L48.23 39.75C48.23 39.62 48.32 39.47 48.42 39.41C48.53 39.35 48.62 39.4 48.62 39.52L48.65 43.15C48.65 43.28 48.56 43.43 48.46 43.49C48.35 43.55 48.26 43.5 48.26 43.38Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M47.45 48.78L47.39 40.25C47.39 40.12 47.48 39.97 47.58 39.91C47.69 39.85 47.78 39.9 47.78 40.02L47.84 48.55C47.84 48.68 47.75 48.83 47.65 48.89C47.54 48.95 47.45 48.9 47.45 48.78Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M48.29 48.29L48.27 44.74C48.27 44.61 48.36 44.46 48.46 44.4C48.57 44.34 48.66 44.39 48.66 44.51L48.68 48.06C48.68 48.19 48.59 48.34 48.49 48.4C48.38 48.46 48.29 48.41 48.29 48.29Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.01 42.65L50.04 47.25C50.04 47.38 50.13 47.43 50.24 47.36C50.35 47.3 50.43 47.14 50.43 47.02L50.4 42.42C50.4 42.29 50.31 42.24 50.2 42.31C50.09 42.37 50.01 42.53 50.01 42.65Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.98 38.73L50 41.31C50 41.44 50.09 41.49 50.2 41.42C50.31 41.36 50.39 41.2 50.39 41.08L50.37 38.5C50.37 38.37 50.28 38.32 50.17 38.39C50.06 38.45 49.98 38.61 49.98 38.73Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.69 45.83L44.66 41.98C44.66 41.85 44.75 41.7 44.85 41.64C44.96 41.58 45.05 41.63 45.05 41.75L45.08 45.6C45.08 45.73 44.99 45.88 44.89 45.94C44.78 46 44.69 45.95 44.69 45.83Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.61 45.36L45.64 49.96C45.64 50.09 45.73 50.14 45.84 50.07C45.95 50.01 46.03 49.85 46.03 49.73L46 45.13C46 45 45.91 44.95 45.8 45.02C45.69 45.08 45.61 45.24 45.61 45.36Z",
					fill: "#AFC7FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M45.58 41.43L45.6 44.01C45.6 44.14 45.69 44.19 45.8 44.12C45.91 44.06 45.99 43.9 45.99 43.78L45.97 41.2C45.97 41.07 45.88 41.02 45.77 41.09C45.66 41.15 45.58 41.31 45.58 41.43Z",
					fill: "#AFC7FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.65 51.38C43.78 51.38 43.92 51.34 44.08 51.25L52.99 46.11C53.21 45.98 53.42 45.77 53.58 45.53L43.66 51.38H43.65Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "multiply" },
			children: /* @__PURE__ */ _jsx("path", {
				d: "M54.76 42.92V36.55L54.24 36.85L50.13 39.32C49.95 39.38 49.64 38.44 49.33 38.59L44.04 41.69C43.63 41.96 43.6 42.31 43.6 42.47L43.64 49.93C43.64 49.93 43.63 51.37 43.65 51.37L53.9 45.33L54.76 42.91V42.92Z",
				fill: "#AFC7FF"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.33 39.76L56.37 36.13C56.43 36.1 56.48 36.09 56.53 36.1C56.58 36.12 56.78 36.21 56.79 36.22L56.28 44.4L43.82 51.6L43.6 51.39L43.89 42.66C43.89 42.44 44.07 42.18 44.21 42.1L49.77 38.83C49.84 38.79 49.89 38.77 49.92 38.78C49.99 38.8 50.12 38.94 50.12 38.94C50.25 39.26 50.21 39.71 50.33 39.75V39.76Z",
			fill: "#BD1B4B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.74 39.79L56.71 36.21C56.71 36.21 56.82 36.21 56.82 36.27L56.57 44.49C56.57 44.59 56.51 44.68 56.43 44.72L43.57 52.21L43.83 51.52L44.1 42.72C44.1 42.56 44.21 42.36 44.35 42.28L50.07 38.92C50.26 38.81 50.57 39.83 50.75 39.77L50.74 39.79Z",
			fill: "#FF467B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.82 51.54C43.82 53.08 41.81 52.21 41.74 50.31C41.77 50.33 41.89 50.4 41.92 50.41C41.92 51.81 43.52 52.73 43.59 51.38C43.62 51.4 43.78 51.51 43.81 51.53L43.82 51.54Z",
			fill: "#F8A119"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.57 35.26C50.28 35.43 49.98 35.6 49.69 35.77C49.54 35.85 49.54 35.63 49.69 35.55C49.98 35.38 50.28 35.21 50.57 35.04C50.72 34.96 50.72 35.18 50.57 35.26Z",
					fill: "#BD1B4B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.1 34.77C51.52 35.11 50.28 35.82 49.7 36.15C49.55 36.23 49.55 36.01 49.7 35.93C50.28 35.59 51.52 34.88 52.1 34.55C52.25 34.47 52.25 34.69 52.1 34.77Z",
					fill: "#BD1B4B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.75 34.01C52.16 34.35 51.57 34.69 50.98 35.03C50.83 35.11 50.83 34.89 50.98 34.81C51.57 34.47 52.16 34.13 52.75 33.79C52.9 33.71 52.9 33.93 52.75 34.01Z",
					fill: "#BD1B4B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.17 35.03L45.52 57.84V46.56L25.02 34.73L24.17 35.03Z",
			fill: "#BABABA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.36 58.52L59.69 50.25V38.97L45.36 47.24V58.52Z",
			fill: "#F8F8F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.17 46.31L45.36 58.52V47.24L24.17 35.03V46.31Z",
			fill: "#E1E1E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.68 46.85L45.36 47.24L59.69 38.97L59.01 38.57L44.68 46.85Z",
			fill: "#BABABA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.09 53.38C52.64 53.38 53.19 53.26 53.61 53.01L56.48 51.35C56.95 51.08 57.22 50.69 57.22 50.27C57.22 49.85 56.87 49.31 56.39 49.04L55.77 48.68C55.6 48.58 55.38 48.64 55.28 48.81C55.18 48.98 55.24 49.2 55.41 49.3L56.03 49.66C56.27 49.8 56.5 50.12 56.5 50.27C56.5 50.42 56.36 50.6 56.12 50.74L53.25 52.4C52.62 52.76 51.46 52.62 50.83 52.25L50.21 51.89C50.04 51.79 49.82 51.85 49.72 52.02C49.62 52.19 49.68 52.41 49.85 52.51L50.47 52.87C50.9 53.12 51.54 53.39 52.09 53.39V53.38Z",
			fill: "#BABABA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.24 48.74C55.24 49.13 55.52 49.29 55.86 49.1C56.2 48.9 56.48 48.42 56.48 48.03C56.48 47.64 56.2 47.48 55.86 47.67C55.52 47.87 55.24 48.35 55.24 48.74Z",
			fill: "#E1E1E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.59 51.83C49.59 52.22 49.87 52.38 50.21 52.19C50.55 51.99 50.83 51.51 50.83 51.12C50.83 50.73 50.55 50.57 50.21 50.76C49.87 50.96 49.59 51.44 49.59 51.83Z",
			fill: "#E1E1E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.34 52.62C52.89 52.62 53.44 52.5 53.86 52.25L56.73 50.59C57.2 50.32 57.47 49.93 57.47 49.51C57.47 49.09 57.21 48.7 56.73 48.43L56.11 48.07C55.94 47.97 55.72 48.03 55.62 48.2C55.52 48.37 55.58 48.59 55.75 48.69L56.37 49.05C56.61 49.19 56.75 49.36 56.75 49.52C56.75 49.68 56.61 49.85 56.37 49.99L53.5 51.65C52.87 52.01 51.8 52.01 51.17 51.65L50.55 51.29C50.38 51.19 50.16 51.25 50.06 51.42C49.96 51.59 50.02 51.81 50.19 51.91L50.81 52.27C51.24 52.52 51.78 52.64 52.33 52.64L52.34 52.62Z",
			fill: "#E1E1E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.86 31.42C25.56 31.9 25.28 32.4 25.02 32.91C24.49 33.92 24.05 34.95 23.7 35.98C22.93 38.2 22.57 40.42 22.66 42.44C22.8 45.68 24.07 48.08 26.24 49.21L29.94 51.13L30.57 49.92C28.82 49.12 27.65 47.14 27.53 44.2C27.45 42.36 27.78 40.38 28.43 38.44C28.96 36.86 29.69 35.31 30.59 33.88C31.51 32.4 32.6 31.06 33.81 29.96C34.42 29.4 35.06 28.9 35.72 28.48C38.2 26.9 40.49 26.71 42.15 27.69L42.56 26.37L39.08 24.55C36.91 23.42 34.22 23.76 31.48 25.5C30.63 26.04 29.81 26.7 29.02 27.46C27.86 28.58 26.8 29.92 25.87 31.42H25.86Z",
			fill: "#F59C16"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.52 44.2C27.27 38.55 30.94 31.51 35.7 28.47C38.34 26.79 40.76 26.69 42.44 27.89L43.49 26.97C43.2 26.74 42.89 26.54 42.56 26.37C40.39 25.24 37.7 25.58 34.96 27.32C32.46 28.92 30.17 31.55 28.51 34.73C26.86 37.91 26.02 41.29 26.15 44.26C26.29 47.5 27.56 49.9 29.73 51.03C30.23 51.29 30.74 51.48 31.27 51.61L31.52 50.56C31.52 50.56 30.71 50.02 30.32 49.81C28.69 48.95 27.63 47.01 27.51 44.21L27.52 44.2Z",
			fill: "#FFF3D5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.16 36.46L11.88 35.33L13.57 34.72L15.85 35.85L14.16 36.46Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.8 49.98L6.51 48.84L6.03 47.09L8.31 48.22L8.8 49.98Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.25 39.25C12.37 41.31 11.08 43.9 9.36 45.03C8.51 45.59 7.71 45.69 7.1 45.39L4.82 44.26C5.42 44.56 6.22 44.46 7.08 43.9C8.8 42.77 10.09 40.18 9.97 38.12C9.91 37.08 9.5 36.37 8.89 36.07L11.17 37.2C11.78 37.5 12.19 38.21 12.25 39.25Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.56 34.11L9.27 32.97L10.67 30.95L12.95 32.08L11.56 34.11Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.06 49.88L1.78 48.75L2.59 46.43L4.87 47.56L4.06 49.88Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.83 34.15C10.54 34.19 10.25 34.27 9.96 34.38L7.68 33.25C7.98 33.14 8.27 33.06 8.55 33.02C8.81 32.98 9.07 32.97 9.28 32.98L11.56 34.11C11.35 34.11 11.1 34.11 10.83 34.15Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.44 46.93C4.57 47.16 4.71 47.37 4.87 47.56L2.59 46.43C2.43 46.25 2.28 46.04 2.16 45.8C2.02 45.54 1.91 45.26 1.82 45.01L4.1 46.14C4.19 46.4 4.3 46.68 4.44 46.93Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.74 36.83C6.49 37.13 6.26 37.44 6.04 37.77L3.76 36.64C3.98 36.31 4.22 36 4.46 35.7C4.73 35.38 5.01 35.08 5.25 34.83L7.53 35.96C7.28 36.21 7 36.5 6.74 36.83Z",
			fill: "#82A5F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.15 42.02C4.05 42.43 3.98 42.83 3.93 43.23L1.65 42.1C1.7 41.71 1.77 41.3 1.87 40.89C1.96 40.51 2.07 40.14 2.17 39.82L4.45 40.95C4.35 41.27 4.24 41.65 4.15 42.02Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.81 33.71L5.53 32.58L7.19 31.49L9.47 32.62L7.81 33.71Z",
			fill: "#82A5F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.53 35.97L5.25 34.83L5.53 32.58L7.81 33.71L7.53 35.97Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.3 44.75L0.0100021 43.62L1.65 42.1L3.93 43.23L2.3 44.75Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.42 46.75L0.130002 45.61L0.0100021 43.62L2.3 44.75L2.42 46.75Z",
			fill: "#4875CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.54 37.6L2.26 36.47L3.75 36.64L6.03 37.77L4.54 37.6Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.45001 40.95L2.16001 39.82L1.17001 38.65L3.45001 39.78L4.45001 40.95Z",
			fill: "#2D5295"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.96001 34.37L9.48 32.62L7.82001 33.71L7.54001 35.97C7.29001 36.22 7.01 36.51 6.75001 36.84C6.50001 37.14 6.27001 37.45 6.05001 37.78L4.55001 37.62L3.46001 39.8L4.46001 40.97C4.36001 41.29 4.25001 41.67 4.16001 42.04C4.06001 42.45 3.99001 42.85 3.94001 43.25L2.31001 44.78L2.43001 46.77L4.12001 46.16C4.21001 46.42 4.32001 46.7 4.46001 46.95C4.59001 47.18 4.73001 47.39 4.89001 47.58L4.08001 49.9L5.34001 50.54L6.73001 48.51C6.94001 48.51 7.20001 48.51 7.46001 48.47C7.75001 48.43 8.04001 48.35 8.33001 48.24L8.81001 49.99L10.47 48.9L10.75 46.64C11 46.39 11.28 46.1 11.54 45.77C11.79 45.47 12.02 45.16 12.24 44.84L13.74 45L14.83 42.82L13.83 41.65C13.93 41.33 14.04 40.95 14.13 40.58C14.23 40.17 14.3 39.77 14.35 39.37L15.98 37.84L15.86 35.85L14.17 36.46C14.08 36.2 13.97 35.92 13.83 35.67C13.7 35.44 13.56 35.23 13.4 35.04L14.21 32.72L12.95 32.08L11.56 34.1C11.35 34.1 11.1 34.1 10.83 34.14C10.54 34.18 10.25 34.26 9.96001 34.37ZM12.25 39.25C12.37 41.31 11.08 43.9 9.36 45.03C7.64001 46.16 6.15001 45.4 6.02001 43.34C5.90001 41.28 7.19001 38.69 8.91001 37.56C10.63 36.43 12.12 37.19 12.25 39.25Z",
			fill: "#5E8CFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.45001 39.78L1.17001 38.65L2.26001 36.47L4.54001 37.6L3.45001 39.78Z",
			fill: "#82A5F8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.07 32.55L13.76 32.9L13.05 34.92C13.01 35.04 13.03 35.18 13.12 35.28C13.26 35.44 13.39 35.63 13.51 35.84C13.62 36.05 13.73 36.31 13.82 36.58C13.85 36.67 13.92 36.75 14.01 36.79C14.06 36.81 14.11 36.83 14.17 36.83C14.21 36.83 14.25 36.83 14.29 36.81L15.52 36.37L15.6 37.71L14.09 39.12C14.03 39.18 13.99 39.26 13.98 39.34C13.93 39.72 13.86 40.11 13.77 40.5C13.69 40.82 13.6 41.17 13.48 41.55C13.44 41.67 13.47 41.8 13.55 41.89L14.39 42.87L13.52 44.61L12.28 44.47C12.28 44.47 12.25 44.47 12.24 44.47C12.12 44.47 12.01 44.53 11.94 44.63C11.72 44.95 11.49 45.25 11.26 45.54C11.03 45.82 10.76 46.11 10.49 46.38C10.43 46.44 10.4 46.51 10.39 46.59L10.13 48.68L9.03 49.4L8.68001 48.13C8.65001 48.03 8.59001 47.95 8.50001 47.9C8.45001 47.87 8.39001 47.86 8.33001 47.86C8.29001 47.86 8.24001 47.86 8.20001 47.88C7.93001 47.98 7.66001 48.05 7.40001 48.09C7.22001 48.12 7.04001 48.13 6.84001 48.13H6.73001C6.61001 48.13 6.50001 48.19 6.43001 48.29L5.22001 50.05L4.53001 49.7L5.24001 47.68C5.28 47.56 5.26001 47.42 5.17001 47.32C5.03001 47.16 4.90001 46.97 4.78001 46.76C4.67001 46.55 4.56 46.29 4.47001 46.02C4.44001 45.93 4.37001 45.85 4.28001 45.81C4.23001 45.79 4.18001 45.77 4.12001 45.77C4.08001 45.77 4.04001 45.77 4.00001 45.79L2.77001 46.23L2.69001 44.89L4.20001 43.48C4.26 43.42 4.30001 43.34 4.31001 43.26C4.36001 42.88 4.43001 42.49 4.52001 42.1C4.60001 41.78 4.69001 41.43 4.81001 41.05C4.85001 40.93 4.82 40.8 4.74001 40.71L3.90001 39.73L4.77001 37.99L6.01001 38.13C6.01001 38.13 6.04001 38.13 6.05001 38.13C6.17001 38.13 6.28001 38.07 6.35001 37.97C6.57 37.65 6.80001 37.35 7.03001 37.06C7.26001 36.78 7.53001 36.49 7.80001 36.22C7.86001 36.16 7.89001 36.09 7.90001 36.01L8.16001 33.92L9.26001 33.2L9.61 34.47C9.64001 34.57 9.70001 34.65 9.79001 34.7C9.84001 34.73 9.90001 34.74 9.96001 34.74C10 34.74 10.05 34.74 10.09 34.72C10.36 34.62 10.63 34.55 10.89 34.51C11.06 34.48 11.25 34.47 11.45 34.47H11.56C11.68 34.47 11.79 34.41 11.86 34.31L13.07 32.55ZM7.84001 45.92C8.38001 45.92 8.98001 45.72 9.56001 45.34C11.37 44.15 12.74 41.41 12.61 39.24C12.52 37.69 11.66 36.68 10.43 36.68C9.89001 36.68 9.29001 36.88 8.71001 37.26C6.90001 38.45 5.53 41.19 5.66001 43.36C5.75001 44.91 6.61001 45.92 7.84001 45.92ZM12.95 32.08L11.56 34.1C11.56 34.1 11.48 34.1 11.44 34.1C11.26 34.1 11.05 34.11 10.83 34.14C10.54 34.18 10.25 34.26 9.96001 34.37L9.48 32.62L7.82001 33.71L7.54001 35.97C7.29001 36.22 7.01 36.51 6.75001 36.84C6.50001 37.14 6.27001 37.45 6.05001 37.78L4.55001 37.62L3.46001 39.8L4.46001 40.97C4.36001 41.29 4.25001 41.67 4.16001 42.04C4.06001 42.45 3.99001 42.85 3.94001 43.25L2.31001 44.78L2.43001 46.77L4.12001 46.16C4.21001 46.42 4.32001 46.7 4.46001 46.95C4.59001 47.18 4.73001 47.39 4.89001 47.58L4.08001 49.9L5.34001 50.54L6.73001 48.51C6.73001 48.51 6.81001 48.51 6.85001 48.51C7.03 48.51 7.24001 48.5 7.46001 48.47C7.75001 48.43 8.04001 48.35 8.33001 48.24L8.81001 49.99L10.47 48.9L10.75 46.64C11 46.39 11.28 46.1 11.54 45.77C11.79 45.47 12.02 45.16 12.24 44.84L13.74 45L14.83 42.82L13.83 41.65C13.93 41.33 14.04 40.95 14.13 40.58C14.23 40.17 14.3 39.77 14.35 39.37L15.98 37.84L15.86 35.85L14.17 36.46C14.08 36.2 13.97 35.92 13.83 35.67C13.7 35.44 13.56 35.23 13.4 35.04L14.21 32.72L12.95 32.08ZM7.84001 45.56C6.84001 45.56 6.11001 44.76 6.02001 43.35C5.90001 41.29 7.19001 38.7 8.91001 37.57C9.45001 37.22 9.97001 37.05 10.43 37.05C11.43 37.05 12.16 37.85 12.25 39.26C12.37 41.32 11.08 43.91 9.36 45.04C8.82 45.4 8.30001 45.56 7.84001 45.56Z",
			fill: "url(#paint2_linear_4252_2707)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_4252_2707",
				x1: 29.4875,
				y1: 19.075,
				x2: 29.5147,
				y2: 19.075,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#82A5F8" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "white"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#82A5F8"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_4252_2707",
				x1: -4.63936,
				y1: 15.54,
				x2: -4.60233,
				y2: 15.54,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#82A5F8" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "white"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#82A5F8"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_4252_2707",
				x1: -9.38252,
				y1: 41.31,
				x2: -9.3553,
				y2: 41.31,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#82A5F8" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "white"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#82A5F8"
					})
				]
			})
		] })
	]
});
export default SvgAutomaticRefinement;
